class I extends Error {
  constructor(e, t, i) {
    super(e), this.code = t, this.context = i, this.name = "HuniDBError";
    const n = Error;
    n.captureStackTrace && n.captureStackTrace(this, this.constructor);
  }
  toJSON() {
    return {
      name: this.name,
      message: this.message,
      code: this.code,
      context: this.context,
      stack: this.stack
    };
  }
}
class L extends I {
  constructor(e, t) {
    super(e, "CONNECTION_ERROR", t), this.name = "ConnectionError";
  }
}
class C extends I {
  constructor(e, t) {
    super(e, "MIGRATION_ERROR", t), this.name = "MigrationError";
  }
}
class f extends I {
  constructor(e, t) {
    super(e, "QUERY_ERROR", t), this.name = "QueryError";
  }
}
class b extends I {
  constructor(e, t) {
    super(e, "SCHEMA_ERROR", t), this.name = "SchemaError";
  }
}
class ae extends I {
  constructor(e, t) {
    super(e, "TRANSACTION_ERROR", t), this.name = "TransactionError";
  }
}
class z extends I {
  constructor(e, t) {
    super(e, "STORAGE_ERROR", t), this.name = "StorageError";
  }
}
class D extends I {
  constructor(e, t) {
    super(e, "INITIALIZATION_ERROR", t), this.name = "InitializationError";
  }
}
function oe(a, e) {
  return a instanceof I ? a : a instanceof Error ? new I(a.message, "UNKNOWN_ERROR", {
    originalError: a.name,
    stack: a.stack
  }) : new I(e, "UNKNOWN_ERROR", {
    originalError: String(a)
  });
}
var V = /* @__PURE__ */ ((a) => (a[a.SILENT = 0] = "SILENT", a[a.ERROR = 1] = "ERROR", a[a.WARN = 2] = "WARN", a[a.INFO = 3] = "INFO", a[a.DEBUG = 4] = "DEBUG", a))(V || {});
class ie {
  constructor(e) {
    this.config = {
      level: 0,
      prefix: "[HuniDB]",
      timestamps: !0,
      ...e
    }, this.metrics = {
      queryCount: 0,
      totalQueryTime: 0,
      averageQueryTime: 0,
      transactionCount: 0,
      totalTransactionTime: 0,
      averageTransactionTime: 0,
      cacheHits: 0,
      cacheMisses: 0,
      cacheHitRate: 0
    }, this.queryTimes = [], this.transactionTimes = [];
  }
  /**
   * Set the log level
   */
  setLevel(e) {
    this.config.level = e;
  }
  /**
   * Get the current log level
   */
  getLevel() {
    return this.config.level;
  }
  /**
   * Check if a log level is enabled
   */
  isEnabled(e) {
    return this.config.level >= e;
  }
  /**
   * Format a log message
   */
  format(e, t, i) {
    const n = this.config.timestamps ? `[${(/* @__PURE__ */ new Date()).toISOString()}]` : "", s = i !== void 0 ? ` ${JSON.stringify(i)}` : "";
    return `${n} ${this.config.prefix} [${e}] ${t}${s}`;
  }
  /**
   * Log an error message
   */
  error(e, t) {
    this.isEnabled(
      1
      /* ERROR */
    ) && console.error(this.format("ERROR", e, t));
  }
  /**
   * Log a warning message
   */
  warn(e, t) {
    this.isEnabled(
      2
      /* WARN */
    ) && console.warn(this.format("WARN", e, t));
  }
  /**
   * Log an info message
   */
  info(e, t) {
    this.isEnabled(
      3
      /* INFO */
    ) && console.info(this.format("INFO", e, t));
  }
  /**
   * Log a debug message
   */
  debug(e, t) {
    this.isEnabled(
      4
      /* DEBUG */
    ) && console.debug(this.format("DEBUG", e, t));
  }
  /**
   * Log a query with execution time
   */
  logQuery(e, t, i) {
    this.metrics.queryCount++, this.metrics.totalQueryTime += i, this.queryTimes.push(i), this.metrics.averageQueryTime = this.metrics.totalQueryTime / this.metrics.queryCount, this.isEnabled(
      4
      /* DEBUG */
    ) && this.debug(`Query executed in ${i.toFixed(2)}ms`, {
      sql: e.trim(),
      params: t,
      executionTime: i
    });
  }
  /**
   * Log a transaction with execution time
   */
  logTransaction(e, t) {
    this.metrics.transactionCount++, this.metrics.totalTransactionTime += e, this.transactionTimes.push(e), this.metrics.averageTransactionTime = this.metrics.totalTransactionTime / this.metrics.transactionCount, this.isEnabled(
      4
      /* DEBUG */
    ) && this.debug(
      `Transaction ${t ? "committed" : "rolled back"} in ${e.toFixed(2)}ms`,
      { executionTime: e, success: t }
    );
  }
  /**
   * Log a cache hit
   */
  logCacheHit() {
    this.metrics.cacheHits++, this.updateCacheHitRate();
  }
  /**
   * Log a cache miss
   */
  logCacheMiss() {
    this.metrics.cacheMisses++, this.updateCacheHitRate();
  }
  /**
   * Update cache hit rate
   */
  updateCacheHitRate() {
    const e = this.metrics.cacheHits + this.metrics.cacheMisses;
    this.metrics.cacheHitRate = e > 0 ? this.metrics.cacheHits / e : 0;
  }
  /**
   * Get performance metrics
   */
  getMetrics() {
    return { ...this.metrics };
  }
  /**
   * Reset performance metrics
   */
  resetMetrics() {
    this.metrics = {
      queryCount: 0,
      totalQueryTime: 0,
      averageQueryTime: 0,
      transactionCount: 0,
      totalTransactionTime: 0,
      averageTransactionTime: 0,
      cacheHits: 0,
      cacheMisses: 0,
      cacheHitRate: 0
    }, this.queryTimes = [], this.transactionTimes = [];
  }
  /**
   * Get query time percentiles
   */
  getQueryPercentiles() {
    if (this.queryTimes.length === 0)
      return { p50: 0, p95: 0, p99: 0 };
    const e = [...this.queryTimes].sort((s, o) => s - o), t = e[Math.floor(e.length * 0.5)] || 0, i = e[Math.floor(e.length * 0.95)] || 0, n = e[Math.floor(e.length * 0.99)] || 0;
    return { p50: t, p95: i, p99: n };
  }
}
const r = new ie();
function ce(a) {
  return new ie(a);
}
const he = "hunidb_storage", x = "databases", le = 1;
class ne {
  constructor() {
    this.db = null, this.isInitialized = !1, this.initPromise = null;
  }
  /**
   * Initialize IndexedDB connection
   */
  async initialize() {
    if (!(this.isInitialized && this.db))
      return this.initPromise ? this.initPromise : (this.initPromise = new Promise((e, t) => {
        if (typeof indexedDB > "u" || !indexedDB) {
          r.warn("IndexedDB not available"), t(new z("IndexedDB is not available"));
          return;
        }
        const i = indexedDB.open(he, le);
        i.onerror = () => {
          r.error("Failed to open IndexedDB for storage", i.error), this.initPromise = null, t(i.error);
        }, i.onsuccess = () => {
          this.db = i.result, this.isInitialized = !0, r.debug("IndexedDB storage initialized"), this.initPromise = null, e();
        }, i.onupgradeneeded = (n) => {
          const s = n.target.result;
          s.objectStoreNames.contains(x) || (s.createObjectStore(x, { keyPath: "name" }), r.debug("Created IndexedDB object store for database storage"));
        };
      }), this.initPromise);
  }
  /**
   * Load database from IndexedDB
   */
  async loadDatabase(e) {
    return this.isInitialized || await this.initialize(), this.db ? new Promise((t, i) => {
      const o = this.db.transaction([x], "readonly").objectStore(x).get(e);
      o.onerror = () => {
        r.error("Failed to load database from IndexedDB", o.error), i(o.error);
      }, o.onsuccess = () => {
        const c = o.result;
        if (r.debug(`IndexedDB get request succeeded for ${e}`, {
          hasResult: !!c,
          resultKeys: c ? Object.keys(c) : [],
          hasData: !!(c && c.data),
          dataType: c?.data ? typeof c.data : "none",
          dataConstructor: c?.data ? c.data.constructor?.name : "none"
        }), c && c.data) {
          let h;
          if (c.data instanceof ArrayBuffer)
            h = new Uint8Array(c.data), r.debug(`Converted ArrayBuffer to Uint8Array (${h.length} bytes)`);
          else if (c.data instanceof Uint8Array)
            h = c.data, r.debug(`Data is already Uint8Array (${h.length} bytes)`);
          else {
            r.warn("Unexpected data type in IndexedDB", {
              dataType: typeof c.data,
              constructor: c.data.constructor?.name,
              keys: Object.keys(c.data || {})
            }), t(null);
            return;
          }
          r.info(`Loaded database ${e} from IndexedDB (${h.length} bytes)`), t(h);
        } else
          r.debug(`No existing database found for ${e}`, {
            hasResult: !!c,
            resultValue: c
          }), t(null);
      };
    }) : null;
  }
  /**
   * Save database to IndexedDB
   */
  async saveDatabase(e, t) {
    if (this.isInitialized || await this.initialize(), !this.db)
      throw new z("IndexedDB not initialized");
    return new Promise((i, n) => {
      const o = this.db.transaction([x], "readwrite").objectStore(x);
      r.debug(`Saving database ${e} to IndexedDB`, {
        dataLength: t.length,
        byteOffset: t.byteOffset,
        byteLength: t.byteLength,
        bufferLength: t.buffer.byteLength,
        firstBytes: Array.from(t.slice(0, 16)).map((l) => `0x${l.toString(16).padStart(2, "0")}`).join(" ")
      });
      let c;
      t.byteOffset === 0 && t.byteLength === t.buffer.byteLength ? c = t.buffer : c = t.buffer.slice(
        t.byteOffset,
        t.byteOffset + t.byteLength
      ), r.debug("Prepared ArrayBuffer for storage", {
        arrayBufferLength: c.byteLength,
        originalDataLength: t.length
      });
      const h = o.put({
        name: e,
        data: c,
        timestamp: Date.now(),
        size: t.length
      });
      h.onerror = () => {
        const l = h.error;
        if (l && (l.name === "InvalidStateError" || typeof l.message == "string" && l.message.toLowerCase().includes("database connection is closing"))) {
          r.warn("IndexedDB save aborted: database connection is closing", {
            name: l.name,
            message: l.message
          }), i();
          return;
        }
        r.error("Failed to save database to IndexedDB", l), n(l);
      }, h.onsuccess = () => {
        r.info(`Saved database ${e} to IndexedDB (${t.length} bytes)`), i();
      };
    });
  }
  /**
   * Delete database from IndexedDB
   */
  async deleteDatabase(e) {
    if (this.isInitialized || await this.initialize(), !!this.db)
      return new Promise((t, i) => {
        const o = this.db.transaction([x], "readwrite").objectStore(x).delete(e);
        o.onerror = () => {
          r.error("Failed to delete database from IndexedDB", o.error), i(o.error);
        }, o.onsuccess = () => {
          r.info(`Deleted database ${e} from IndexedDB`), t();
        };
      });
  }
  /**
   * List all databases in IndexedDB
   */
  async listDatabases() {
    return this.isInitialized || await this.initialize(), this.db ? new Promise((e, t) => {
      const s = this.db.transaction([x], "readonly").objectStore(x).getAllKeys();
      s.onerror = () => {
        r.error("Failed to list databases from IndexedDB", s.error), t(s.error);
      }, s.onsuccess = () => {
        const o = s.result;
        r.debug(`Found ${o.length} database(s) in IndexedDB storage: ${o.join(", ")}`), e(o);
      };
    }) : [];
  }
  /**
   * Close IndexedDB connection
   */
  close() {
    this.db && (this.db.close(), this.db = null, this.isInitialized = !1, this.initPromise = null);
  }
}
function N(a) {
  const e = Object.prototype.toString.call(a);
  return e === "[object ArrayBuffer]" || e === "[object SharedArrayBuffer]";
}
function J(a) {
  if (!a)
    return null;
  const e = a.wasm;
  if (e?.memory instanceof WebAssembly.Memory)
    try {
      const t = e.memory.buffer;
      if (t && N(t)) {
        const i = t.byteLength;
        if (i > 0)
          return r.debug("Created fresh heap view from WebAssembly.Memory", {
            byteLength: i,
            isSharedArrayBuffer: typeof SharedArrayBuffer < "u" && t instanceof SharedArrayBuffer
          }), new Uint8Array(t);
        r.warn("WebAssembly.Memory.buffer has zero byteLength (detached)", {
          bufferType: t.constructor.name
        });
      }
    } catch (t) {
      r.warn("Error accessing WASM memory buffer", t);
    }
  else e && r.debug("WebAssembly.Memory not available, falling back to heap properties", {
    hasMemory: !!e.memory,
    memoryType: e.memory ? typeof e.memory : "undefined"
  });
  if (e?.heap8u) {
    const t = F(e.heap8u, "heap8u");
    if (t) return t;
  }
  if (e?.heap8) {
    const t = F(e.heap8, "heap8");
    if (t) return t;
  }
  if (a.HEAPU8) {
    const t = F(a.HEAPU8, "HEAPU8 (sqlite)");
    if (t) return t;
  }
  if (e?.HEAPU8) {
    const t = F(e.HEAPU8, "HEAPU8 (wasm)");
    if (t) return t;
  }
  if (e?.HEAP8) {
    const t = F(e.HEAP8, "HEAP8 (wasm)");
    if (t) return t;
  }
  return r.warn("Could not find WASM heap Uint8Array", {
    hasWasm: !!e,
    hasMemory: !!e?.memory,
    wasmKeys: e ? Object.keys(e).slice(0, 15) : [],
    sqliteKeys: Object.keys(a).slice(0, 15)
  }), null;
}
function F(a, e) {
  try {
    if (typeof a == "function") {
      const t = a();
      if (t instanceof Uint8Array && typeof t.set == "function")
        return t.buffer?.byteLength > 0 && t.length > 0 ? t : (r.warn(`Ignoring ${e} view from function because buffer is detached or zero-length`, {
          length: t.length,
          bufferSize: t.buffer?.byteLength ?? 0
        }), null);
      if (t?.buffer && N(t.buffer)) {
        const i = new Uint8Array(t.buffer);
        return i.buffer.byteLength > 0 && i.length > 0 ? i : (r.warn(`Ignoring ${e} view (from function buffer) because buffer is detached or zero-length`, {
          length: i.length,
          bufferSize: i.buffer.byteLength,
          bufferType: i.buffer.constructor.name
        }), null);
      }
      return r.debug(`Found ${e} as function, but result is not a valid Uint8Array`, {
        type: t && typeof t,
        constructor: t?.constructor?.name
      }), null;
    }
    if (a instanceof Uint8Array && typeof a.set == "function")
      return a.buffer?.byteLength > 0 && a.length > 0 ? a : (r.warn(`Ignoring ${e} Uint8Array because buffer is detached or zero-length`, {
        length: a.length,
        bufferSize: a.buffer?.byteLength ?? 0
      }), null);
    if (a instanceof Int8Array) {
      const t = a.buffer;
      if (t && N(t) && t.byteLength > 0) {
        const i = new Uint8Array(t);
        if (i.length > 0)
          return i;
      }
      return r.warn(`Ignoring ${e} Int8Array-based view because buffer is detached or zero-length`, {
        length: a.length,
        bufferSize: t?.byteLength ?? 0,
        bufferType: t?.constructor?.name ?? "unknown"
      }), null;
    }
    if (a && typeof a == "object" && "buffer" in a) {
      const t = a.buffer;
      if (t && N(t) && t.byteLength > 0) {
        const i = new Uint8Array(t);
        if (i.length > 0)
          return i;
      }
      return r.warn(`Ignoring ${e} buffer-based view because buffer is detached or zero-length`, {
        bufferSize: t?.byteLength ?? 0,
        bufferType: t?.constructor?.name ?? "unknown"
      }), null;
    }
    r.debug(`Found ${e} but it's not a valid TypedArray`, {
      type: typeof a,
      constructor: a?.constructor?.name,
      hasBuffer: !!a?.buffer
    });
  } catch (t) {
    r.warn(`Error accessing ${e}`, t);
  }
  return null;
}
function U(a) {
  if (typeof a == "number")
    return a;
  if (!a || typeof a != "object")
    return null;
  const e = ["pointer", "$$", "db", "_db"];
  for (const t of e) {
    const i = a[t];
    if (typeof i == "number" && i !== 0)
      return i;
    if (i && typeof i == "object" && i.filename) {
      const n = U(i);
      if (n) return n;
    }
  }
  return null;
}
function de(a, e, t) {
  if (!(a && N(a.buffer)))
    throw new Error("Invalid heap Uint8Array - buffer is not ArrayBuffer or SharedArrayBuffer");
  const n = a.buffer.byteLength, s = a.length;
  if (n === 0 || s === 0)
    throw new Error(`Heap buffer is detached (byteLength: ${n}, length: ${s}). This usually means WASM memory grew and the view became stale. Caller should re-fetch the heap view.`);
  if (e < 0 || t < 0)
    throw new Error(`Invalid pointer or size: pointer=${e}, size=${t}`);
  const o = e + t, c = Math.max(s, n);
  if (o > c) {
    r.warn("Copy size exceeds heap size, truncating", {
      pointer: e,
      size: t,
      heapViewLength: s,
      heapBufferSize: n,
      availableHeapSize: c,
      endPointer: o,
      isSharedArrayBuffer: typeof SharedArrayBuffer < "u" && a.buffer instanceof SharedArrayBuffer
    });
    const d = Math.max(0, c - e);
    if (d === 0)
      throw new Error(`Pointer ${e} is beyond heap size ${c}`);
    t = d;
  }
  let h = a;
  s < n && o > s && (h = new Uint8Array(a.buffer));
  const l = h.subarray(e, e + t);
  return new Uint8Array(l);
}
function ue(a, e, t) {
  if (!a || !(a.buffer instanceof ArrayBuffer))
    throw new Error("Invalid heap Uint8Array");
  if (e < 0 || t.length < 0)
    throw new Error(`Invalid pointer or data length: pointer=${e}, length=${t.length}`);
  const i = a.buffer.byteLength, n = e + t.length;
  if (n > i) {
    if (a.length < i) {
      const s = new Uint8Array(a.buffer);
      if (n <= s.length) {
        s.set(t, e);
        return;
      }
    }
    throw new Error(`Data size ${t.length} exceeds available heap space at pointer ${e} (buffer size: ${i}, view length: ${a.length})`);
  }
  a.set(t, e);
}
function fe(a, e) {
  if (!a || e <= 0)
    return null;
  const t = a.wasm;
  if (!t)
    return r.warn("WASM module not available for memory allocation"), null;
  if (typeof t.alloc == "function")
    try {
      const i = t.alloc(e);
      if (i && i !== 0)
        return i;
    } catch (i) {
      r.warn("wasm.alloc failed", i);
    }
  if (typeof t._malloc == "function")
    try {
      const i = t._malloc(e);
      if (i && i !== 0)
        return i;
    } catch (i) {
      r.warn("wasm._malloc failed", i);
    }
  if (typeof t.malloc == "function")
    try {
      const i = t.malloc(e);
      if (i && i !== 0)
        return i;
    } catch (i) {
      r.warn("wasm.malloc failed", i);
    }
  return r.error("All memory allocation methods failed", {
    size: e,
    hasAlloc: typeof t.alloc == "function",
    hasMalloc: typeof t._malloc == "function",
    hasMallocAlt: typeof t.malloc == "function"
  }), null;
}
function se(a, e) {
  if (!a || !e || e === 0)
    return !1;
  const t = a.wasm, i = a.capi;
  if (t && typeof t.dealloc == "function")
    try {
      return t.dealloc(e), !0;
    } catch (n) {
      r.debug("wasm.dealloc failed, trying alternatives", n);
    }
  if (t && typeof t._free == "function")
    try {
      return t._free(e), !0;
    } catch (n) {
      r.debug("wasm._free failed, trying alternatives", n);
    }
  if (t && typeof t.free == "function")
    try {
      return t.free(e), !0;
    } catch (n) {
      r.debug("wasm.free failed, trying alternatives", n);
    }
  if (i && typeof i.sqlite3_free == "function")
    try {
      return i.sqlite3_free(e), !0;
    } catch (n) {
      r.debug("capi.sqlite3_free failed", n);
    }
  return r.warn("All memory deallocation methods failed", {
    ptr: e,
    hasDealloc: t && typeof t.dealloc == "function",
    hasFree: t && typeof t._free == "function",
    hasFreeAlt: t && typeof t.free == "function",
    hasSqliteFree: i && typeof i.sqlite3_free == "function"
  }), !1;
}
function _(a, e) {
  try {
    se(a, e);
  } catch (t) {
    r.warn("Error freeing WASM memory", {
      ptr: e,
      error: t instanceof Error ? t.message : String(t)
    });
  }
}
const ge = "3.53.4-build2", me = {
  version: ge
}, ye = 256 * 65536, pe = me.version;
function G(a, e) {
  const t = `v=${encodeURIComponent(pe)}`, i = e ? `${e}&${t}` : t;
  return `${a}?${i}`;
}
function Ee(a) {
  const e = a.split("?"), t = e[0] || a, i = e[1];
  let n = t;
  t.startsWith("/public/") ? n = t.substring(8) : t.startsWith("public/") && (n = t.substring(7));
  const s = n.split("/").pop() || n;
  if (!(s === "sqlite3.wasm" || s.startsWith("sqlite3-") && (s.endsWith(".js") || s.endsWith(".mjs")))) {
    const h = n !== t ? n.startsWith("/") ? n : `/${n}` : t;
    return i ? `${h}?${i}` : h;
  }
  if (n.startsWith("http"))
    return G(n, i);
  let c;
  return n.startsWith("/assets/") || n.startsWith("assets/") ? c = n.startsWith("/") ? n : `/${n}` : n.startsWith("/") ? c = n : c = `/assets/${s}`, G(c, i);
}
let M = 0;
const k = 500 * 1024 * 1024;
let j = null;
function Xe(a) {
  j = a;
}
function q() {
  if (!j)
    return !1;
  try {
    return j() === !0;
  } catch {
    return !1;
  }
}
class we {
  constructor(e, t) {
    this.sqlite = null, this.db = null, this.isInitialized = !1, this.indexedDBStorage = null, this.saveTimer = null, this.saveLock = Promise.resolve(), this.isSaving = !1, this.dbName = e, this.storageType = t, this.generation = ++M;
  }
  /**
   * Initialize SQLite WASM and create/open database
   */
  async initialize() {
    if (!this.isInitialized)
      try {
        r.info(`Initializing SQLite engine for database: ${this.dbName}`), this.sqlite = await this.loadSQLiteWASM();
        const e = this.sqlite.capi.sqlite3_libversion();
        if (r.info(`SQLite version: ${e}`), this.storageType === "indexeddb" ? this.db = await this.openIndexedDBDatabase() : this.db = await this.openMemoryDatabase(), this.db.exec("PRAGMA foreign_keys = ON"), this.db.exec("SELECT json_valid('{}') as test"), this.db.selectValue("SELECT 1") !== 1)
          throw new Error("Database test query failed");
        this.isInitialized = !0, r.info("SQLite engine initialized successfully");
      } catch (e) {
        throw new D(
          `Failed to initialize SQLite engine: ${e instanceof Error ? e.message : String(e)}`,
          { dbName: this.dbName, storageType: this.storageType, error: e }
        );
      }
  }
  /**
   * Load SQLite WASM module
   */
  async loadSQLiteWASM() {
    try {
      const t = (await import("./index-lvuFUKuu.js")).default;
      return await t({
        print: (n) => r.debug("SQLite:", n),
        printErr: (n) => r.error("SQLite error:", n),
        INITIAL_MEMORY: ye,
        // Vite publicDir is static-pwa/; copy-sqlite-workers.js places files in static-pwa/assets.
        // Do not use import.meta.env.PROD here: this package is prebuilt (libs/huni_db/dist),
        // so PROD is fixed at library build time, not at app dev/prod runtime.
        locateFile: Ee
      });
    } catch (e) {
      const t = (s) => {
        if (s instanceof Error)
          return { name: s.name, message: s.message };
        if (s != null)
          return String(s);
      }, i = e instanceof Error && "cause" in e ? t(e.cause) : void 0, n = e instanceof Error ? {
        name: e.name,
        message: e.message,
        stack: e.stack,
        cause: i
      } : { value: String(e) };
      throw new D("Failed to load SQLite WASM module", {
        error: n,
        hint: "Check Network tab for /assets/sqlite3.wasm (404, COEP/CORP, or a year-cached older build whose memory import is 256 pages while this glue allocates 128)."
      });
    }
  }
  /**
   * Open database with IndexedDB storage
   */
  async openIndexedDBDatabase() {
    if (!this.sqlite)
      throw new D("SQLite not initialized");
    try {
      this.indexedDBStorage = new ne(), await this.indexedDBStorage.initialize(), r.debug(`Attempting to load database ${this.dbName} from IndexedDB...`);
      const e = await this.indexedDBStorage.loadDatabase(this.dbName);
      r.debug(`loadDatabase returned: ${e ? `${e.length} bytes` : "null"}`);
      const t = new this.sqlite.oo1.DB(":memory:");
      if (e && e.length > 0) {
        r.info(`Loading existing database ${this.dbName} from IndexedDB (${e.length} bytes)`);
        try {
          const i = this.sqlite.capi, n = U(t);
          if (!n)
            throw new Error("Could not get database handle for deserialization");
          r.debug("Database handle for deserialize", {
            pDb: !!n,
            pDbType: typeof n
          });
          const s = fe(this.sqlite, e.length);
          if (!s)
            throw new Error("Failed to allocate WASM memory for deserialization");
          const o = J(this.sqlite);
          if (!o)
            throw _(this.sqlite, s), new Error("Cannot access WASM heap for deserialization");
          r.debug(`Copying ${e.length} bytes to WASM memory at pointer ${s}...`, {
            heapViewLength: o.length,
            heapBufferSize: o.buffer.byteLength,
            pointer: s,
            dataSize: e.length
          }), ue(o, s, e), r.debug(`Copied ${e.length} bytes to WASM memory at pointer ${s}`);
          const l = 1 | 2;
          r.debug("Calling sqlite3_deserialize...", {
            pDb: !!n,
            dataLength: e.length,
            flags: l
          });
          const d = i.sqlite3_deserialize(
            n,
            "main",
            s,
            e.length,
            // szDb: bytes to deserialize
            e.length,
            // szBuf: total buffer size
            l
          );
          if (r.debug(`sqlite3_deserialize returned: ${d}`), d !== 0)
            _(this.sqlite, s), r.warn(`Failed to deserialize database, creating new one. Error code: ${d}`);
          else {
            r.info("Successfully loaded database from IndexedDB");
            try {
              const g = t.selectValue("SELECT COUNT(*) FROM sqlite_master WHERE type='table' AND name NOT LIKE 'sqlite_%'");
              r.info(`Database loaded successfully - found ${g} user table(s)`), g === 0 && r.warn("Database loaded but contains no tables - this might indicate a deserialization issue");
            } catch (g) {
              r.warn("Could not verify loaded database", g);
            }
          }
        } catch (i) {
          r.warn(`Error loading database from IndexedDB: ${i instanceof Error ? i.message : String(i)}. Creating new database.`);
        }
      } else
        r.info(`Creating new database ${this.dbName} in IndexedDB`);
      return r.info(`Opened IndexedDB database: ${this.dbName}`), t;
    } catch (e) {
      throw new D(
        "Failed to open IndexedDB database",
        { error: e }
      );
    }
  }
  /**
   * Save database to IndexedDB
   * 
   * CRITICAL: This method is protected by a save lock to prevent concurrent saves
   * which could cause database corruption. Only one save operation can run at a time.
   */
  async saveToIndexedDB() {
    if (q())
      return;
    if (!this.db || !this.indexedDBStorage || this.storageType !== "indexeddb" || !this.sqlite) {
      r.warn("Skipping save - missing requirements", {
        hasDb: !!this.db,
        hasStorage: !!this.indexedDBStorage,
        storageType: this.storageType,
        hasSqlite: !!this.sqlite
      });
      return;
    }
    const e = this.generation;
    return new Promise((t, i) => {
      this.saveLock = this.saveLock.then(async () => {
        if (e !== M) {
          r.debug("Skipping saveToIndexedDB - engine generation is outdated", {
            dbName: this.dbName,
            engineGeneration: e,
            globalEngineGeneration: M
          }), t();
          return;
        }
        if (this.isSaving) {
          r.warn("Save already in progress, skipping duplicate save"), t();
          return;
        }
        this.isSaving = !0;
        try {
          r.debug(`Starting save to IndexedDB for database: ${this.dbName}`), await new Promise((u) => setTimeout(u, 10));
          const n = this.db;
          if (typeof n.export == "function") {
            r.debug("Using oo1.DB.export() method");
            const u = n.export();
            if (u && u.length > 0 && this.indexedDBStorage) {
              await this.indexedDBStorage.saveDatabase(this.dbName, u);
              try {
                const E = await this.indexedDBStorage.loadDatabase(this.dbName);
                if (!E || E.length === 0)
                  throw new Error("Saved database validation failed: loaded data is empty");
                if (E.length !== u.length)
                  throw new Error(`Saved database validation failed: size mismatch (saved: ${u.length}, loaded: ${E.length})`);
                if (!(u.length > 0 && E.length > 0 && u[0] === E[0] && u[1] === E[1] && u[2] === E[2] && u[3] === E[3]))
                  throw new Error("Saved database validation failed: header mismatch");
                r.debug("Database save validation passed");
              } catch (E) {
                r.error("Database save validation failed - corruption detected!", E);
              }
              r.debug(`Successfully saved database ${this.dbName} to IndexedDB using export() (${u.length} bytes)`), t();
              return;
            } else
              r.warn("export() returned empty data, falling back to sqlite3_serialize");
          }
          if (!this.sqlite) {
            i(new Error("SQLite instance is null"));
            return;
          }
          const s = this.sqlite.capi, o = U(this.db);
          if (!o) {
            r.error("Could not get database handle for serialization"), i(new Error("Could not get database handle for serialization"));
            return;
          }
          r.debug("Database handle obtained", {
            pDb: !!o,
            pDbType: typeof o
          }), r.debug("Calling sqlite3_serialize...");
          let c;
          try {
            c = s.sqlite3_serialize(o, "main", null, null);
          } catch (u) {
            throw r.error("sqlite3_serialize threw an error", u), u;
          }
          if (!c || c === 0) {
            r.error("Failed to serialize database (returned null/zero pointer). Database may be empty or handle is invalid."), r.debug("Debug info:", {
              pDb: o,
              dbFilename: this.db?.filename,
              hasCapi: !!s,
              hasSerialize: typeof s.sqlite3_serialize == "function",
              serializeResult: c
            }), i(new Error("Failed to serialize database"));
            return;
          }
          r.debug("Serialization successful, getting size...");
          let h = 0;
          try {
            h = s.sqlite3_serialize_size(o, "main"), r.debug(`Serialized size from sqlite3_serialize_size: ${h} bytes`);
          } catch (u) {
            r.warn("sqlite3_serialize_size failed, using alternative size calculation", u);
            try {
              const E = this.db.selectValue("PRAGMA page_size"), B = this.db.selectValue("PRAGMA page_count");
              E && B ? (h = E * B, r.debug(`Calculated size from page_size * page_count: ${h} bytes`)) : (h = 10 * 1024 * 1024, r.debug(`Using fallback size: ${h} bytes`));
            } catch (E) {
              r.error("Size calculation methods failed", E), _(this.sqlite, c), i(new Error("Size calculation methods failed"));
              return;
            }
          }
          if (h === 0) {
            r.warn("Serialized database size is 0 - database may be empty"), _(this.sqlite, c), i(new Error("Serialized database size is 0"));
            return;
          }
          if (h > k) {
            r.error("Serialized database size exceeds maximum allowed", {
              size: h,
              maxSize: k,
              dbName: this.dbName
            }), _(this.sqlite, c), i(new Error(`Serialized database size ${h} exceeds maximum allowed ${k}`));
            return;
          }
          const l = J(this.sqlite);
          if (!l) {
            r.error("Cannot access WASM heap for serialization (post-serialize)"), _(this.sqlite, c), i(new Error("Cannot access WASM heap for serialization (post-serialize)"));
            return;
          }
          const d = l.buffer?.byteLength ?? 0, g = l.length ?? 0;
          if (Math.max(d, g) === 0) {
            r.warn("Skipping IndexedDB save - WASM heap is empty after serialize", {
              heapBufferSize: d,
              heapViewLength: g,
              dbName: this.dbName
            }), _(this.sqlite, c), i(new Error("WASM heap is empty after serialize"));
            return;
          }
          const T = h;
          r.debug(`Copying ${T} bytes from WASM memory at pointer ${c}...`, {
            heapU8Length: l.length,
            bufferLength: l.buffer.byteLength,
            pointer: c,
            pointerPlusSize: c + T
          });
          let m;
          try {
            m = de(l, c, T), r.debug(`Created data copy: ${m.length} bytes`, {
              originalSize: h,
              copySize: T,
              firstBytes: m.length > 0 ? Array.from(m.slice(0, Math.min(16, m.length))).map((u) => `0x${u.toString(16).padStart(2, "0")}`).join(" ") : "empty"
            });
          } catch (u) {
            r.error("Failed to copy data from WASM heap", u), _(this.sqlite, c), i(u);
            return;
          }
          if (r.debug(`Saving ${m.length} bytes to IndexedDB...`), !this.indexedDBStorage) {
            _(this.sqlite, c), i(new Error("IndexedDB storage is null"));
            return;
          }
          const p = `${this.dbName}__tmp`;
          await this.indexedDBStorage.saveDatabase(p, m), se(this.sqlite, c);
          try {
            const u = await this.indexedDBStorage.loadDatabase(p);
            if (!u || u.length === 0)
              throw new Error("Saved database validation failed: loaded data is empty");
            if (u.length !== m.length)
              throw new Error(`Saved database validation failed: size mismatch (saved: ${m.length}, loaded: ${u.length})`);
            if (!(m.length > 0 && u.length > 0 && m[0] === u[0] && m[1] === u[1] && m[2] === u[2] && m[3] === u[3]))
              throw new Error("Saved database validation failed: header mismatch");
            r.debug("Database save validation passed for temp image"), await this.indexedDBStorage.saveDatabase(this.dbName, u);
          } catch (u) {
            r.error("Database save validation failed - corruption detected!", u);
          }
          r.debug(`Successfully saved database ${this.dbName} to IndexedDB (${m.length} bytes)`), t();
        } catch (n) {
          r.error("Failed to save database to IndexedDB", n), console.error("IndexedDB save error details:", n), n instanceof Error && console.error("Error stack:", n.stack), i(n);
        } finally {
          this.isSaving = !1;
        }
      }).catch((n) => {
        r.error("Error in save lock chain", n), i(n);
      });
    });
  }
  /**
   * Schedule a save to IndexedDB (debounced)
   */
  scheduleSave() {
    q() || this.storageType !== "indexeddb" || !this.indexedDBStorage || this.isSaving || (this.saveTimer && clearTimeout(this.saveTimer), this.saveTimer = setTimeout(() => {
      this.flush(!1).catch((e) => {
        r.error("Error in scheduled save", e);
      });
    }, 8e3));
  }
  /**
   * Open database in memory
   */
  async openMemoryDatabase() {
    if (!this.sqlite)
      throw new D("SQLite not initialized");
    try {
      const e = ":memory:", t = new this.sqlite.oo1.DB(e);
      return r.info(`Opened memory database: ${e}`), t;
    } catch (e) {
      throw new D(
        "Failed to open memory database",
        { error: e }
      );
    }
  }
  /**
   * Execute a SQL statement (INSERT, UPDATE, DELETE, CREATE, etc.)
   */
  async exec(e, t) {
    this.ensureInitialized();
    const i = performance.now();
    try {
      t && t.length > 0 ? this.db.exec({
        sql: e,
        bind: t
      }) : this.db.exec(e);
      const n = performance.now() - i;
      r.logQuery(e, t, n), !e.trim().toUpperCase().startsWith("SELECT") && this.storageType === "indexeddb" && this.scheduleSave();
    } catch (n) {
      throw new f(
        `Failed to execute SQL: ${n instanceof Error ? n.message : String(n)}`,
        { sql: e, params: t, error: n }
      );
    }
  }
  /**
   * Execute a SELECT query and return all rows
   */
  async query(e, t) {
    this.ensureInitialized();
    const i = performance.now();
    try {
      const n = this.db.selectObjects(e, t), s = performance.now() - i;
      return r.logQuery(e, t, s), n;
    } catch (n) {
      throw new f(
        `Failed to execute query: ${n instanceof Error ? n.message : String(n)}`,
        { sql: e, params: t, error: n }
      );
    }
  }
  /**
   * Execute a SELECT query and return the first row
   */
  async queryOne(e, t) {
    const i = await this.query(e, t);
    return i.length > 0 ? i[0] ?? null : null;
  }
  /**
   * Execute a SELECT query and return a single value
   */
  async queryValue(e, t) {
    this.ensureInitialized();
    const i = performance.now();
    try {
      const n = this.db.selectValue(e, t), s = performance.now() - i;
      return r.logQuery(e, t, s), n === void 0 ? null : n;
    } catch (n) {
      throw new f(
        `Failed to execute query: ${n instanceof Error ? n.message : String(n)}`,
        { sql: e, params: t, error: n }
      );
    }
  }
  /**
   * Begin a transaction
   */
  async beginTransaction() {
    await this.exec("BEGIN TRANSACTION");
  }
  /**
   * Commit a transaction
   */
  async commit() {
    await this.exec("COMMIT");
  }
  /**
   * Rollback a transaction
   */
  async rollback() {
    await this.exec("ROLLBACK");
  }
  /**
   * Execute a function within a transaction
   */
  async transaction(e) {
    this.ensureInitialized();
    const t = performance.now();
    await this.beginTransaction();
    try {
      const i = await e();
      await this.commit();
      const n = performance.now() - t;
      return r.logTransaction(n, !0), this.storageType === "indexeddb" && this.scheduleSave(), i;
    } catch (i) {
      await this.rollback();
      const n = performance.now() - t;
      throw r.logTransaction(n, !1), oe(i, "Transaction failed");
    }
  }
  /**
   * Prepare a SQL statement
   */
  prepare(e) {
    this.ensureInitialized();
    try {
      return this.db.prepare(e);
    } catch (t) {
      throw new f(
        `Failed to prepare statement: ${t instanceof Error ? t.message : String(t)}`,
        { sql: e, error: t }
      );
    }
  }
  /**
   * Close the database
   */
  async close() {
    if (this.db) {
      try {
        this.storageType === "indexeddb" && (this.saveTimer && (clearTimeout(this.saveTimer), this.saveTimer = null), await this.saveToIndexedDB()), this.db.close(), r.info(`Closed database: ${this.dbName}`);
      } catch (e) {
        r.error("Failed to close database", e);
      }
      this.db = null, this.isInitialized = !1, this.indexedDBStorage && (this.indexedDBStorage.close(), this.indexedDBStorage = null);
    }
  }
  /**
   * Check if engine is initialized
   */
  isReady() {
    return this.isInitialized && this.db !== null;
  }
  /**
   * Ensure engine is initialized
   */
  ensureInitialized() {
    if (!this.isInitialized || !this.db)
      throw new D("SQLite engine not initialized. Call initialize() first.");
  }
  /**
   * Get database filename
   */
  getFilename() {
    return this.db?.filename ?? "";
  }
  /**
   * Get storage type
   */
  getStorageType() {
    return this.storageType;
  }
  /**
   * Force immediate save to IndexedDB (flush pending changes)
   * 
   * This method waits for any pending writes to complete before saving,
   * ensuring data consistency.
   * 
   * @param immediate - If true, flush immediately. If false, defer to next idle period to avoid blocking UI.
   */
  async flush(e = !1) {
    if (!q() && this.storageType === "indexeddb") {
      if (this.saveTimer && (clearTimeout(this.saveTimer), this.saveTimer = null), !e && typeof window < "u")
        return new Promise((t, i) => {
          const n = async () => {
            if (this.isSaving) {
              r.debug(`[SQLiteEngine] Flush skipped for ${this.dbName} - save already in progress`), t();
              return;
            }
            try {
              await this.saveToIndexedDB(), t();
            } catch (s) {
              r.error(`[SQLiteEngine] Flush failed for ${this.dbName}:`, s), i(s);
            }
          };
          typeof window < "u" && "scheduler" in window && "postTask" in window.scheduler ? window.scheduler.postTask(n, { priority: "background" }) : window.requestIdleCallback ? window.requestIdleCallback(n, { timeout: 1e4 }) : setTimeout(n, 0);
        });
      try {
        await this.saveToIndexedDB();
      } catch (t) {
        throw r.error(`[SQLiteEngine] Immediate flush failed for ${this.dbName}:`, t), t;
      }
    }
  }
}
async function Q() {
  const a = {
    indexedDB: !1
  };
  try {
    a.indexedDB = "indexedDB" in window && window.indexedDB !== null, a.indexedDB && r.debug("IndexedDB is available");
  } catch (e) {
    r.debug("IndexedDB not available", e);
  }
  return a;
}
async function Y(a) {
  const e = await Q();
  if (a)
    switch (a) {
      case "indexeddb":
        if (e.indexedDB)
          return r.info("Using preferred storage: indexeddb"), "indexeddb";
        r.warn("Preferred storage indexeddb not available, falling back to memory");
        break;
      case "memory":
        return r.info("Using preferred storage: memory"), "memory";
    }
  return e.indexedDB ? (r.info("Auto-selected storage: indexeddb"), "indexeddb") : (r.warn("No persistent storage available, using memory"), "memory");
}
async function Te(a) {
  const e = {
    type: a,
    available: !0
  };
  try {
    if (a === "indexeddb" && "storage" in navigator && "estimate" in navigator.storage) {
      const t = await navigator.storage.estimate();
      e.usage = t.usage, e.quota = t.quota, e.usage && e.quota && (e.size = e.usage);
    }
  } catch (t) {
    r.warn("Failed to get storage info", t);
  }
  return e;
}
async function Ve(a) {
  const e = await Q();
  switch (a) {
    case "indexeddb":
      return e.indexedDB;
    case "memory":
      return !0;
    default:
      return !1;
  }
}
function be() {
  const a = navigator.userAgent;
  let e = "Unknown", t = "Unknown";
  return a.includes("Chrome") && !a.includes("Edg") ? (e = "Chrome", t = a.match(/Chrome\/(\d+)/)?.[1] ?? "Unknown") : a.includes("Edg") ? (e = "Edge", t = a.match(/Edg\/(\d+)/)?.[1] ?? "Unknown") : a.includes("Safari") && !a.includes("Chrome") ? (e = "Safari", t = a.match(/Version\/(\d+)/)?.[1] ?? "Unknown") : a.includes("Firefox") && (e = "Firefox", t = a.match(/Firefox\/(\d+)/)?.[1] ?? "Unknown"), { name: e, version: t, userAgent: a };
}
async function Qe() {
  const a = await Q(), e = be();
  if (!a.indexedDB)
    throw new z(
      "No compatible storage mechanism available. Browser must support IndexedDB.",
      { browserInfo: e, capabilities: a }
    );
  r.debug("Storage compatibility validated", { browserInfo: e, capabilities: a });
}
async function Ke(a, e) {
  try {
    if (e === "indexeddb") {
      try {
        const t = new ne();
        await t.initialize(), await t.deleteDatabase(a), t.close();
      } catch (t) {
        r.debug("Failed to clear from IndexedDB storage store", t);
      }
      try {
        await new Promise((t) => {
          const i = indexedDB.deleteDatabase(a);
          i.onsuccess = () => {
            r.info(`Cleared IndexedDB storage for database: ${a}`), t();
          }, i.onerror = () => {
            t();
          }, i.onblocked = () => {
            r.warn("Database deletion blocked, close all connections first"), t();
          };
        });
      } catch (t) {
        r.debug("Failed to delete IndexedDB database", t);
      }
    }
  } catch (t) {
    throw new z(
      `Failed to clear storage for database: ${a}`,
      { error: t, type: e }
    );
  }
}
class Se {
  constructor(e = 200) {
    this.cache = /* @__PURE__ */ new Map(), this.maxSize = e;
  }
  /**
   * Get a prepared statement from cache or prepare a new one
   */
  get(e, t) {
    const i = this.cache.get(e);
    if (i) {
      i.lastUsed = Date.now(), i.useCount++, r.logCacheHit(), r.debug(`Prepared statement cache hit for SQL: ${e.substring(0, 50)}...`);
      try {
        i.statement.reset();
      } catch {
        return this.cache.delete(e), r.debug("Statement reset failed, preparing new one"), this.prepareAndCache(e, t);
      }
      return i.statement;
    }
    return r.logCacheMiss(), this.prepareAndCache(e, t);
  }
  /**
   * Prepare a statement and add it to cache
   */
  prepareAndCache(e, t) {
    this.cache.size >= this.maxSize && this.evictLRU();
    const i = t(e);
    return this.cache.set(e, {
      statement: i,
      lastUsed: Date.now(),
      useCount: 1
    }), r.debug(`Prepared and cached statement: ${e.substring(0, 50)}...`), i;
  }
  /**
   * Evict least recently used entry
   */
  evictLRU() {
    let e = null, t = 1 / 0;
    for (const [i, n] of this.cache.entries())
      n.lastUsed < t && (t = n.lastUsed, e = i);
    if (e) {
      const i = this.cache.get(e);
      if (i)
        try {
          i.statement.finalize();
        } catch (n) {
          r.debug("Error finalizing evicted statement", n);
        }
      this.cache.delete(e), r.debug(`Evicted LRU statement: ${e.substring(0, 50)}...`);
    }
  }
  /**
   * Remove a specific statement from cache
   */
  remove(e) {
    const t = this.cache.get(e);
    if (t) {
      try {
        t.statement.finalize();
      } catch (i) {
        r.debug("Error finalizing removed statement", i);
      }
      this.cache.delete(e);
    }
  }
  /**
   * Clear all cached statements
   */
  clear() {
    for (const e of this.cache.values())
      try {
        e.statement.finalize();
      } catch (t) {
        r.debug("Error finalizing statement during clear", t);
      }
    this.cache.clear(), r.info("Prepared statement cache cleared");
  }
  /**
   * Get cache statistics
   */
  getStats() {
    const e = Array.from(this.cache.entries()).map(([i, n]) => ({
      sql: i.length > 100 ? i.substring(0, 100) + "..." : i,
      useCount: n.useCount,
      lastUsed: n.lastUsed
    })), t = r.getMetrics();
    return {
      size: this.cache.size,
      maxSize: this.maxSize,
      hitRate: t.cacheHitRate,
      statements: e
    };
  }
  /**
   * Get current cache size
   */
  size() {
    return this.cache.size;
  }
  /**
   * Check if cache contains a statement
   */
  has(e) {
    return this.cache.has(e);
  }
  /**
   * Set maximum cache size
   */
  setMaxSize(e) {
    for (this.maxSize = e; this.cache.size > this.maxSize; )
      this.evictLRU();
  }
  /**
   * Get maximum cache size
   */
  getMaxSize() {
    return this.maxSize;
  }
}
function W(a) {
  if (!(a instanceof Error))
    return !1;
  const e = a.message.toLowerCase(), t = a.name.toLowerCase(), i = [
    "locked",
    "busy",
    "timeout",
    "temporary",
    "interrupted",
    "io error",
    "network",
    "connection",
    "eagain",
    "ewouldblock"
  ];
  for (const n of i)
    if (e.includes(n))
      return !0;
  for (const n of i)
    if (t.includes(n))
      return !0;
  return a instanceof I ? ["CONNECTION_ERROR", "QUERY_ERROR"].includes(a.code) : !1;
}
function $e(a) {
  return new Promise((e) => setTimeout(e, a));
}
const Ie = {
  maxRetries: 3,
  initialDelay: 100,
  maxDelay: 5e3,
  backoffMultiplier: 2,
  shouldRetry: W,
  onRetry: () => {
  }
};
async function Z(a, e = {}) {
  const t = { ...Ie, ...e };
  let i, n = t.initialDelay;
  for (let s = 0; s <= t.maxRetries; s++)
    try {
      return await a();
    } catch (o) {
      if (i = o, s === t.maxRetries)
        break;
      if (!t.shouldRetry(o, s))
        throw r.debug("Error is not transient, not retrying", {
          error: o instanceof Error ? o.message : String(o),
          attempt: s + 1
        }), o;
      n = Math.min(n * t.backoffMultiplier, t.maxDelay), t.onRetry(o, s + 1, n), r.debug(`Retrying after ${n}ms (attempt ${s + 1}/${t.maxRetries})`, {
        error: o instanceof Error ? o.message : String(o)
      }), await $e(n);
    }
  throw r.warn("All retries exhausted", {
    maxRetries: t.maxRetries,
    lastError: i instanceof Error ? i.message : String(i)
  }), i;
}
class xe {
  constructor(e, t, i = 200, n = 0, s = !0, o = 3) {
    this.dbName = e, this.storageType = t, this.writeLock = Promise.resolve(), this.isOpen = !1, this.engine = new we(e, t), this.statementCache = new Se(i), this.queryTimeout = n, this.retryEnabled = s, this.maxRetries = o;
  }
  /**
   * Open the connection
   */
  async open() {
    if (!this.isOpen)
      try {
        await this.engine.initialize(), this.isOpen = !0, r.info(`Connection opened for database: ${this.dbName}`);
      } catch (e) {
        throw new L(
          `Failed to open connection: ${e instanceof Error ? e.message : String(e)}`,
          { dbName: this.dbName, storageType: this.storageType, error: e }
        );
      }
  }
  /**
   * Close the connection
   */
  async close() {
    this.isOpen && (await this.writeLock, this.statementCache.clear(), await this.engine.close(), this.isOpen = !1, r.info(`Connection closed for database: ${this.dbName}`));
  }
  /**
   * Execute a SQL statement with write serialization
   */
  async exec(e, t) {
    this.ensureOpen(), this.writeLock = this.writeLock.then(async () => {
      await this.engine.exec(e, t);
    }), await this.writeLock;
  }
  /**
   * Execute a SELECT query (concurrent reads allowed)
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds (overrides default)
   * @returns Promise resolving to array of result rows
   * @throws QueryError if query fails or times out
   */
  async query(e, t, i) {
    this.ensureOpen();
    const n = i ?? this.queryTimeout, s = () => this.engine.query(e, t);
    return n > 0 ? Promise.race([
      s(),
      new Promise((o, c) => {
        setTimeout(() => {
          c(new f(`Query timeout after ${n}ms`, { sql: e, timeout: n }));
        }, n);
      })
    ]) : this.retryEnabled ? Z(s, {
      maxRetries: this.maxRetries,
      shouldRetry: W
    }) : s();
  }
  /**
   * Execute a SELECT query and return first row
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds
   * @returns Promise resolving to first row or null
   */
  async queryOne(e, t, i) {
    this.ensureOpen();
    const n = await this.query(e, t, i);
    return n.length > 0 ? n[0] ?? null : null;
  }
  /**
   * Execute a SELECT query and return single value
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds
   * @returns Promise resolving to single value or null
   */
  async queryValue(e, t, i) {
    this.ensureOpen();
    const n = i ?? this.queryTimeout, s = () => this.engine.queryValue(e, t);
    return n > 0 ? Promise.race([
      s(),
      new Promise((o, c) => {
        setTimeout(() => {
          c(new f(`Query timeout after ${n}ms`, { sql: e, timeout: n }));
        }, n);
      })
    ]) : this.retryEnabled ? Z(s, {
      maxRetries: this.maxRetries,
      shouldRetry: W
    }) : s();
  }
  /**
   * Execute a transaction
   */
  async transaction(e) {
    return this.ensureOpen(), new Promise((t, i) => {
      this.writeLock = this.writeLock.then(async () => {
        try {
          const n = await this.engine.transaction(e);
          t(n);
        } catch (n) {
          i(n);
        }
      });
    });
  }
  /**
   * Get the underlying engine (for advanced use)
   */
  getEngine() {
    return this.engine;
  }
  /**
   * Get the statement cache
   */
  getStatementCache() {
    return this.statementCache;
  }
  /**
   * Get database name
   */
  getDatabaseName() {
    return this.dbName;
  }
  /**
   * Get storage type
   */
  getStorageType() {
    return this.storageType;
  }
  /**
   * Force immediate save to IndexedDB (flush pending changes)
   */
  async flush(e = !1) {
    await this.engine.flush(e);
  }
  /**
   * Check if connection is open
   */
  isConnected() {
    return this.isOpen && this.engine.isReady();
  }
  /**
   * Ensure connection is open
   */
  ensureOpen() {
    if (!this.isOpen)
      throw new L("Connection is not open. Call open() first.");
  }
}
const y = class y {
  // 30 seconds
  constructor() {
    this.connections = /* @__PURE__ */ new Map();
  }
  /**
   * Get singleton instance
   */
  static getInstance() {
    return y.instance || (y.instance = new y()), y.instance;
  }
  /**
   * Get or create a connection
   * 
   * @throws ConnectionError if maximum connections reached
   */
  async getConnection(e) {
    const t = this.getConnectionKey(e.name, e.storage);
    if (this.connections.has(t)) {
      const s = this.connections.get(t);
      if (s.isConnected())
        return r.debug(`Reusing existing connection for: ${e.name}`), s;
      this.connections.delete(t);
    }
    if (this.connections.size >= y.MAX_CONNECTIONS)
      throw new L(
        `Maximum connections (${y.MAX_CONNECTIONS}) reached. Close existing connections first.`,
        {
          currentConnections: this.connections.size,
          maxConnections: y.MAX_CONNECTIONS,
          connectionNames: Array.from(this.connections.keys())
        }
      );
    const i = e.storage === "auto" || !e.storage ? await Y() : await Y(e.storage), n = new xe(
      e.name,
      i,
      e.cache?.statementLimit,
      e.queryTimeout ?? y.DEFAULT_QUERY_TIMEOUT,
      e.retryEnabled ?? !0,
      e.maxRetries ?? 3
    );
    return await n.open(), this.connections.set(t, n), r.info(`Created new connection for: ${e.name} using ${i}`), n;
  }
  /**
   * Close a specific connection
   */
  async closeConnection(e, t) {
    const i = this.getConnectionKey(e, t || "auto"), n = this.connections.get(i);
    n && (await n.close(), this.connections.delete(i), r.info(`Connection closed and removed for: ${e}`));
  }
  /**
   * Close all connections
   */
  async closeAll() {
    const e = Array.from(this.connections.values()).map(
      (t) => t.close().catch((i) => {
        r.error("Error closing connection", i);
      })
    );
    await Promise.all(e), this.connections.clear(), r.info("All connections closed");
  }
  /**
   * Get number of active connections
   */
  getConnectionCount() {
    return this.connections.size;
  }
  /**
   * Get maximum allowed connections
   */
  getMaxConnections() {
    return y.MAX_CONNECTIONS;
  }
  /**
   * Check if connection limit is reached
   */
  isConnectionLimitReached() {
    return this.connections.size >= y.MAX_CONNECTIONS;
  }
  /**
   * Get all connection names
   */
  getConnectionNames() {
    return Array.from(this.connections.keys());
  }
  /**
   * Check if a connection exists
   */
  hasConnection(e, t) {
    const i = this.getConnectionKey(e, t || "auto");
    return this.connections.has(i);
  }
  /**
   * Generate connection key
   */
  getConnectionKey(e, t) {
    return `${e}:${t || "auto"}`;
  }
  /**
   * Reset the singleton instance (for testing)
   */
  static reset() {
    y.instance && (y.instance.closeAll().catch(() => {
    }), y.instance = null);
  }
};
y.instance = null, y.MAX_CONNECTIONS = 10, y.DEFAULT_QUERY_TIMEOUT = 3e4;
let H = y;
function K() {
  return H.getInstance();
}
const v = "_migrations";
class Re {
  constructor(e) {
    this.connection = e;
  }
  /**
   * Initialize migration table
   */
  async initializeMigrationTable() {
    const e = `
      CREATE TABLE IF NOT EXISTS ${v} (
        version INTEGER PRIMARY KEY,
        description TEXT,
        applied_at INTEGER NOT NULL
      )
    `;
    await this.connection.exec(e), r.debug("Migration table initialized");
  }
  /**
   * Get current migration version
   */
  async getCurrentVersion() {
    return await this.initializeMigrationTable(), await this.connection.queryValue(
      `SELECT MAX(version) FROM ${v}`
    ) ?? 0;
  }
  /**
   * Get all applied migrations
   */
  async getAppliedMigrations() {
    return await this.initializeMigrationTable(), await this.connection.query(
      `SELECT version, description, applied_at FROM ${v} ORDER BY version ASC`
    );
  }
  /**
   * Check if a migration has been applied
   */
  async isMigrationApplied(e) {
    return await this.initializeMigrationTable(), (await this.connection.queryValue(
      `SELECT COUNT(*) FROM ${v} WHERE version = ?`,
      [e]
    ) ?? 0) > 0;
  }
  /**
   * Run migrations up to a target version
   */
  async migrate(e, t) {
    this.validateMigrations(e);
    const i = [...e].sort((o, c) => o.version - c.version), n = await this.getCurrentVersion(), s = t ?? i[i.length - 1]?.version ?? 0;
    r.info(`Current migration version: ${n}`), r.info(`Target migration version: ${s}`), s < n ? await this.rollback(i, s) : s > n ? await this.applyMigrations(i, n, s) : r.info("Database is already at target version");
  }
  /**
   * Apply migrations
   */
  async applyMigrations(e, t, i) {
    const n = e.filter(
      (s) => s.version > t && s.version <= i
    );
    if (n.length === 0) {
      r.info("No migrations to apply");
      return;
    }
    r.info(`Applying ${n.length} migration(s)`);
    for (const s of n)
      await this.applyMigration(s);
    r.info("All migrations applied successfully");
  }
  /**
   * Apply a single migration
   */
  async applyMigration(e) {
    const t = performance.now();
    try {
      r.info(`Applying migration ${e.version}: ${e.description || "Unnamed"}`);
      const i = this.connection.getEngine();
      await i.transaction(async () => {
        const s = {
          exec: async (o, c) => {
            await i.exec(o, c);
          },
          query: async (o, c) => await i.query(o, c)
        };
        await e.up(s), await i.exec(
          `INSERT INTO ${v} (version, description, applied_at) VALUES (?, ?, ?)`,
          [e.version, e.description || null, Date.now()]
        );
      });
      const n = performance.now() - t;
      r.info(
        `Migration ${e.version} applied successfully in ${n.toFixed(2)}ms`
      );
    } catch (i) {
      throw new C(
        `Failed to apply migration ${e.version}: ${i instanceof Error ? i.message : String(i)}`,
        { migration: e.version, description: e.description, error: i }
      );
    }
  }
  /**
   * Rollback migrations to a target version
   */
  async rollback(e, t) {
    const i = await this.getCurrentVersion(), n = e.filter((s) => s.version > t && s.version <= i).sort((s, o) => o.version - s.version);
    if (n.length === 0) {
      r.info("No migrations to rollback");
      return;
    }
    r.info(`Rolling back ${n.length} migration(s)`);
    for (const s of n)
      await this.rollbackMigration(s);
    r.info("All migrations rolled back successfully");
  }
  /**
   * Rollback a single migration
   */
  async rollbackMigration(e) {
    const t = performance.now();
    try {
      r.info(`Rolling back migration ${e.version}: ${e.description || "Unnamed"}`);
      const i = this.connection.getEngine();
      await i.transaction(async () => {
        const s = {
          exec: async (o, c) => {
            await i.exec(o, c);
          },
          query: async (o, c) => await i.query(o, c)
        };
        await e.down(s), await this.connection.exec(
          `DELETE FROM ${v} WHERE version = ?`,
          [e.version]
        );
      });
      const n = performance.now() - t;
      r.info(
        `Migration ${e.version} rolled back successfully in ${n.toFixed(2)}ms`
      );
    } catch (i) {
      throw new C(
        `Failed to rollback migration ${e.version}: ${i instanceof Error ? i.message : String(i)}`,
        { migration: e.version, description: e.description, error: i }
      );
    }
  }
  /**
   * Validate migrations
   */
  validateMigrations(e) {
    if (e.length === 0)
      return;
    const t = /* @__PURE__ */ new Set();
    for (const n of e) {
      if (t.has(n.version))
        throw new C(
          `Duplicate migration version: ${n.version}`,
          { version: n.version }
        );
      if (t.add(n.version), !Number.isInteger(n.version) || n.version <= 0)
        throw new C(
          `Invalid migration version: ${n.version}. Must be a positive integer.`,
          { version: n.version }
        );
      if (typeof n.up != "function")
        throw new C(
          `Migration ${n.version} is missing 'up' function`,
          { version: n.version }
        );
      if (typeof n.down != "function")
        throw new C(
          `Migration ${n.version} is missing 'down' function`,
          { version: n.version }
        );
    }
    const i = Array.from(t).sort((n, s) => n - s);
    for (let n = 1; n < i.length; n++) {
      const s = i[n - 1], o = i[n];
      s !== void 0 && o !== void 0 && o !== s + 1 && r.warn(
        `Gap detected in migration versions: ${s} -> ${o}`
      );
    }
  }
  /**
   * Reset all migrations (dangerous - for testing only)
   */
  async reset() {
    r.warn("Resetting all migrations - this is a destructive operation!"), await this.connection.exec(`DROP TABLE IF EXISTS ${v}`), r.info("All migrations reset");
  }
  /**
   * Get migration status
   */
  async getStatus(e) {
    const t = await this.getCurrentVersion(), i = [...e].sort((c, h) => c.version - h.version), n = i[i.length - 1]?.version ?? 0, s = i.filter((c) => c.version > t).map((c) => c.version), o = await this.getAppliedMigrations();
    return {
      currentVersion: t,
      availableVersion: n,
      pendingMigrations: s,
      appliedMigrations: o
    };
  }
}
function P(a) {
  return new Re(a);
}
const R = class R {
  constructor(e) {
    this.connection = e;
  }
  /**
   * Initialize index tables for a JSON table
   */
  async initializeTable(e, t) {
    try {
      const i = e.replace(/\./g, "_");
      await this.connection.exec(`
        CREATE TABLE IF NOT EXISTS ${this.getKeysTableName(e)} (
          table_name TEXT NOT NULL,
          key_path TEXT NOT NULL,
          doc_id TEXT NOT NULL,
          PRIMARY KEY (table_name, key_path, doc_id)
        )
      `), await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS "${i}_keys_path" 
        ON ${this.getKeysTableName(e)}(key_path, doc_id)
      `), await this.connection.exec(`
        CREATE TABLE IF NOT EXISTS ${this.getValuesTableName(e)} (
          table_name TEXT NOT NULL,
          key_path TEXT NOT NULL,
          value_hash TEXT,
          doc_id TEXT NOT NULL,
          value_text TEXT,
          value_type TEXT,
          PRIMARY KEY (table_name, key_path, doc_id, value_hash)
        )
      `), await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS "${i}_values_key" 
        ON ${this.getValuesTableName(e)}(key_path, value_hash)
      `), await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS "${i}_values_text" 
        ON ${this.getValuesTableName(e)}(key_path, value_text)
      `), await this.createTriggers(e), r.debug(`Initialized indexes for JSON table: ${e}`);
    } catch (i) {
      throw new f(
        `Failed to initialize indexes: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, options: t, error: i }
      );
    }
  }
  /**
   * Create triggers for automatic index maintenance
   */
  async createTriggers(e) {
    const t = e.replace(/\./g, "_");
    await this.connection.exec(`DROP TRIGGER IF EXISTS "trg_${t}_insert"`), await this.connection.exec(`DROP TRIGGER IF EXISTS "trg_${t}_update"`), await this.connection.exec(`DROP TRIGGER IF EXISTS "trg_${t}_delete"`);
  }
  /**
   * Index a document (extract keys and values)
   */
  async indexDocument(e, t, i) {
    try {
      await this.removeDocument(e, t);
      const n = this.extractKeys(i), s = this.extractValues(i);
      for (const o of n)
        await this.connection.exec(
          `INSERT OR REPLACE INTO ${this.getKeysTableName(e)} (table_name, key_path, doc_id) VALUES (?, ?, ?)`,
          [e, o, t]
        );
      for (const { keyPath: o, hash: c, text: h, type: l } of s)
        await this.connection.exec(
          `INSERT OR REPLACE INTO ${this.getValuesTableName(e)} (table_name, key_path, value_hash, doc_id, value_text, value_type) VALUES (?, ?, ?, ?, ?, ?)`,
          [e, o, c, t, h, l]
        );
    } catch (n) {
      try {
        let s = null;
        try {
          const o = JSON.stringify(i), c = 5e3;
          s = o.length > c ? `${o.slice(0, c)}... [truncated, length=${o.length}]` : o;
        } catch (o) {
          s = `[unstringifiable document: ${o instanceof Error ? o.message : String(o)}]`;
        }
        r.error("JSONIndexer: Failed to index document", {
          tableName: e,
          docId: t,
          docPreview: s,
          errorMessage: n instanceof Error ? n.message : String(n)
        });
      } catch {
      }
      throw new f(
        `Failed to index document: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, docId: t, error: n }
      );
    }
  }
  /**
   * Remove document from indexes
   */
  async removeDocument(e, t) {
    try {
      await this.connection.exec(
        `DELETE FROM ${this.getKeysTableName(e)} WHERE table_name = ? AND doc_id = ?`,
        [e, t]
      ), await this.connection.exec(
        `DELETE FROM ${this.getValuesTableName(e)} WHERE table_name = ? AND doc_id = ?`,
        [e, t]
      );
    } catch (i) {
      throw new f(
        `Failed to remove document from indexes: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, docId: t, error: i }
      );
    }
  }
  /**
   * Rebuild all indexes for a table
   */
  async rebuildIndexes(e) {
    try {
      await this.connection.exec(`DELETE FROM ${this.getKeysTableName(e)} WHERE table_name = ?`, [e]), await this.connection.exec(`DELETE FROM ${this.getValuesTableName(e)} WHERE table_name = ?`, [e]);
      const t = await this.connection.query(
        `SELECT id, doc FROM ${this.escapeIdentifier(e)}`
      );
      for (const { id: i, doc: n } of t) {
        const s = JSON.parse(n);
        await this.indexDocument(e, i, s);
      }
      r.info(`Rebuilt indexes for ${e}: ${t.length} documents`);
    } catch (t) {
      throw new f(
        `Failed to rebuild indexes: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Get list of indexed keys for a table
   */
  async getIndexedKeys(e) {
    try {
      return (await this.connection.query(
        `SELECT DISTINCT key_path FROM ${this.getKeysTableName(e)} WHERE table_name = ? ORDER BY key_path`,
        [e]
      )).map((i) => i.key_path);
    } catch (t) {
      throw new f(
        `Failed to get indexed keys: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Drop index tables for a table
   */
  async dropTable(e) {
    try {
      await this.connection.exec(`DROP TABLE IF EXISTS ${this.getKeysTableName(e)}`), await this.connection.exec(`DROP TABLE IF EXISTS ${this.getValuesTableName(e)}`);
    } catch (t) {
      throw new f(
        `Failed to drop index tables: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Extract all key paths from a JSON object
   * 
   * Uses a WeakSet to avoid infinite recursion on cyclic structures.
   */
  extractKeys(e, t = "", i = /* @__PURE__ */ new WeakSet(), n = 0, s = { count: 0 }) {
    const o = [];
    if (e == null || n > R.MAX_DEPTH || s.count > R.MAX_NODES)
      return o;
    if (typeof e == "object" && !Array.isArray(e)) {
      const c = e;
      if (i.has(c))
        return o;
      i.add(c);
      for (const [h, l] of Object.entries(e)) {
        if (s.count++, s.count > R.MAX_NODES)
          break;
        const d = t ? `${t}.${h}` : h;
        o.push(d), typeof l == "object" && l !== null && !Array.isArray(l) && o.push(...this.extractKeys(l, d, i, n + 1, s));
      }
    }
    return o;
  }
  /**
   * Extract all values from a JSON object with their paths
   * 
   * Uses a WeakSet to avoid infinite recursion on cyclic structures.
   */
  extractValues(e, t = "", i = /* @__PURE__ */ new WeakSet(), n = 0, s = { count: 0 }) {
    const o = [];
    if (e == null || n > R.MAX_DEPTH || s.count > R.MAX_NODES)
      return o;
    if (Array.isArray(e))
      e.forEach((c, h) => {
        const l = t ? `${t}[${h}]` : `[${h}]`;
        o.push(...this.extractValues(c, l, i, n + 1, s));
      });
    else if (typeof e == "object") {
      const c = e;
      if (i.has(c))
        return o;
      i.add(c);
      for (const [h, l] of Object.entries(e)) {
        if (s.count++, s.count > R.MAX_NODES)
          break;
        const d = t ? `${t}.${h}` : h, g = this.hashValue(l), w = typeof l == "string" ? l : null, T = this.getType(l);
        o.push({
          keyPath: d,
          value: l,
          hash: g,
          text: w,
          type: T
        }), typeof l == "object" && l !== null && o.push(...this.extractValues(l, d, i, n + 1, s));
      }
    } else {
      const c = t || "value", h = this.hashValue(e), l = typeof e == "string" ? e : null, d = this.getType(e);
      o.push({
        keyPath: c,
        value: e,
        hash: h,
        text: l,
        type: d
      });
    }
    return o;
  }
  /**
   * Hash a value for indexing
   */
  hashValue(e) {
    const t = JSON.stringify(e);
    let i = 0;
    for (let n = 0; n < t.length; n++) {
      const s = t.charCodeAt(n);
      i = (i << 5) - i + s, i = i & i;
    }
    return i.toString(36);
  }
  /**
   * Get type of a value
   */
  getType(e) {
    return e === null ? "null" : Array.isArray(e) ? "array" : typeof e;
  }
  /**
   * Get keys table name
   */
  getKeysTableName(e) {
    return this.escapeIdentifier(`json_keys_${e}`);
  }
  /**
   * Get values table name
   */
  getValuesTableName(e) {
    return this.escapeIdentifier(`json_values_${e}`);
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
};
R.MAX_DEPTH = 16, R.MAX_NODES = 5e4;
let X = R;
class re {
  /**
   * Build a FIND query from a filter
   */
  buildFindQuery(e, t) {
    const i = [];
    let n = `SELECT doc FROM ${this.escapeIdentifier(e)}`;
    const s = this.buildWhereClause(e, t, i);
    return s && (n += ` WHERE ${s}`), (t.sortAsc || t.sortDesc) && (n += this.buildOrderBy(t)), t.limit !== void 0 && (n += " LIMIT ?", i.push(t.limit)), t.offset !== void 0 && (n += " OFFSET ?", i.push(t.offset)), { sql: n, params: i };
  }
  /**
   * Build a COUNT query from a filter
   */
  buildCountQuery(e, t) {
    const i = [];
    let n = `SELECT COUNT(*) FROM ${this.escapeIdentifier(e)}`;
    const s = this.buildWhereClause(e, t, i);
    return s && (n += ` WHERE ${s}`), { sql: n, params: i };
  }
  /**
   * Build WHERE clause from filter
   */
  buildWhereClause(e, t, i) {
    const n = [];
    if (t.and && t.and.length > 0) {
      const s = t.and.map((o) => this.buildWhereClause(e, o, i)).filter((o) => o);
      s.length > 0 && n.push(`(${s.join(" AND ")})`);
    }
    if (t.or && t.or.length > 0) {
      const s = t.or.map((o) => this.buildWhereClause(e, o, i)).filter((o) => o);
      s.length > 0 && n.push(`(${s.join(" OR ")})`);
    }
    if (t.not) {
      const s = this.buildWhereClause(e, t.not, i);
      s && n.push(`NOT (${s})`);
    }
    if (t.hasKey) {
      const s = Array.isArray(t.hasKey) ? t.hasKey : [t.hasKey], o = s.map(() => `EXISTS (
          SELECT 1 FROM ${this.getKeysTableName(e)} 
          WHERE table_name = ? AND key_path = ? AND doc_id = ${this.escapeIdentifier(e)}.id
        )`);
      i.push(...s.map(() => e), ...s.map((c) => this.normalizeKeyPath(c))), n.push(`(${o.join(" OR ")})`);
    }
    if (t.eq)
      for (const [s, o] of Object.entries(t.eq))
        n.push(this.buildValueCondition(e, s, "=", o, i));
    if (t.ne)
      for (const [s, o] of Object.entries(t.ne))
        n.push(this.buildValueCondition(e, s, "!=", o, i));
    if (t.gt)
      for (const [s, o] of Object.entries(t.gt))
        n.push(this.buildValueCondition(e, s, ">", o, i));
    if (t.gte)
      for (const [s, o] of Object.entries(t.gte))
        n.push(this.buildValueCondition(e, s, ">=", o, i));
    if (t.lt)
      for (const [s, o] of Object.entries(t.lt))
        n.push(this.buildValueCondition(e, s, "<", o, i));
    if (t.lte)
      for (const [s, o] of Object.entries(t.lte))
        n.push(this.buildValueCondition(e, s, "<=", o, i));
    if (t.in) {
      for (const [s, o] of Object.entries(t.in))
        if (o.length > 0) {
          const c = this.normalizeKeyPath(s), h = o.map((d) => this.hashValue(d)), l = h.map(() => "?").join(", ");
          i.push(e, c, ...h), n.push(`EXISTS (
            SELECT 1 FROM ${this.getValuesTableName(e)}
            WHERE table_name = ? AND key_path = ? AND value_hash IN (${l}) AND doc_id = ${this.escapeIdentifier(e)}.id
          )`);
        }
    }
    if (t.like)
      for (const [s, o] of Object.entries(t.like)) {
        const c = this.normalizeKeyPath(s);
        i.push(e, c, o), n.push(`EXISTS (
          SELECT 1 FROM ${this.getValuesTableName(e)}
          WHERE table_name = ? AND key_path = ? AND value_text LIKE ? AND doc_id = ${this.escapeIdentifier(e)}.id
        )`);
      }
    if (t.match)
      for (const [, s] of Object.entries(t.match))
        i.push(s), n.push(`json_extract(${this.escapeIdentifier(e)}.doc, ?) MATCH ?`);
    return n.length > 0 ? n.join(" AND ") : "";
  }
  /**
   * Build a value condition using index tables
   */
  buildValueCondition(e, t, i, n, s) {
    const o = this.normalizeKeyPath(t), c = this.hashValue(n);
    if (i === "=" || i === "!=") {
      const l = i === "!=" ? "NOT " : "";
      return s.push(e, o, c), `${l}EXISTS (
        SELECT 1 FROM ${this.getValuesTableName(e)}
        WHERE table_name = ? AND key_path = ? AND value_hash = ? AND doc_id = ${this.escapeIdentifier(e)}.id
      )`;
    }
    const h = `$.${o}`;
    return s.push(h, n), `json_extract(${this.escapeIdentifier(e)}.doc, ?) ${i} ?`;
  }
  /**
   * Build ORDER BY clause
   */
  buildOrderBy(e) {
    const t = [];
    if (e.sortAsc) {
      const i = Array.isArray(e.sortAsc) ? e.sortAsc : [e.sortAsc];
      for (const n of i) {
        const s = this.normalizeKeyPath(n);
        t.push(`json_extract(doc, '$.${s}') ASC`);
      }
    }
    if (e.sortDesc) {
      const i = Array.isArray(e.sortDesc) ? e.sortDesc : [e.sortDesc];
      for (const n of i) {
        const s = this.normalizeKeyPath(n);
        t.push(`json_extract(doc, '$.${s}') DESC`);
      }
    }
    return t.length > 0 ? ` ORDER BY ${t.join(", ")}` : "";
  }
  /**
   * Normalize key path (convert dot notation to JSON path)
   */
  normalizeKeyPath(e) {
    return e.replace(/\./g, ".");
  }
  /**
   * Hash a value (simple implementation)
   */
  hashValue(e) {
    const t = JSON.stringify(e);
    let i = 0;
    for (let n = 0; n < t.length; n++) {
      const s = t.charCodeAt(n);
      i = (i << 5) - i + s, i = i & i;
    }
    return i.toString(36);
  }
  /**
   * Get keys table name
   */
  getKeysTableName(e) {
    return this.escapeIdentifier(`json_keys_${e}`);
  }
  /**
   * Get values table name
   */
  getValuesTableName(e) {
    return this.escapeIdentifier(`json_values_${e}`);
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
}
class Oe {
  constructor(e) {
    this.connection = e;
  }
  /**
   * Create FTS5 virtual table for a JSON table
   */
  async createFTSIndex(e, t) {
    try {
      const i = `${e}_fts`, n = t?.tokenizer || "unicode61";
      r.info(`Creating FTS5 index: ${i} for table: ${e}`), await this.connection.exec(`DROP TABLE IF EXISTS ${this.escapeIdentifier(i)}`), r.debug(`Dropped existing FTS table if it existed: ${i}`);
      try {
        await this.connection.exec(`
          CREATE VIRTUAL TABLE ${this.escapeIdentifier(i)}
          USING fts5(
            doc_id UNINDEXED,
            content,
            tokenize='${n}'
          )
        `), r.debug(`Created FTS5 virtual table: ${i}`);
      } catch (o) {
        throw r.error(`Failed to create FTS5 table: ${o}`), new f(
          `Failed to create FTS5 virtual table: ${o instanceof Error ? o.message : String(o)}. FTS5 may not be enabled in SQLite.`,
          { tableName: e, ftsTableName: i, error: o }
        );
      }
      const s = await this.connection.queryValue(
        "SELECT COUNT(*) FROM sqlite_master WHERE type='table' AND name=?",
        [i]
      );
      if (!s || s === 0)
        throw r.error(`FTS5 table verification failed: ${i} does not exist after creation`), new f(
          `Failed to create FTS5 table: ${i}. FTS5 may not be enabled in SQLite.`,
          { tableName: e, ftsTableName: i }
        );
      r.debug(`Verified FTS5 table creation: ${i}`), await this.createSyncTriggers(e, i), r.debug(`Created sync triggers for: ${i}`);
      try {
        await this.populateFTSIndex(e, i), r.debug("Populated FTS index with existing documents");
      } catch (o) {
        throw r.error(`Failed to populate FTS index: ${o instanceof Error ? o.message : String(o)}`), o;
      }
      try {
        const o = await this.connection.queryValue(
          `SELECT COUNT(*) FROM ${this.escapeIdentifier(i)}`
        );
        r.info(`Created FTS5 index: ${i} for table: ${e} with ${o || 0} indexed documents`);
      } catch (o) {
        r.error(`Failed to verify FTS index: ${o instanceof Error ? o.message : String(o)}`);
      }
    } catch (i) {
      throw new f(
        `Failed to create FTS5 index: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, options: t, error: i }
      );
    }
  }
  /**
   * Check if FTS index exists
   */
  async exists(e) {
    try {
      const t = `${e}_fts`;
      return (await this.connection.queryValue(
        "SELECT COUNT(*) FROM sqlite_master WHERE type='table' AND name=?",
        [t]
      ) ?? 0) > 0;
    } catch {
      return !1;
    }
  }
  /**
   * Search using FTS5
   */
  async search(e, t, i) {
    try {
      const n = `${e}_fts`, s = i?.limit || 100, o = i?.offset || 0;
      if (!await this.exists(e)) {
        const d = await this.connection.queryValue(
          "SELECT COUNT(*) FROM sqlite_master WHERE type='table' AND name=?",
          [e]
        );
        throw !d || d === 0 ? new f(
          `Table '${e}' does not exist. Please create it first.`,
          { tableName: e }
        ) : new f(
          `FTS5 index does not exist for table '${e}'. Please create it first using: db.json.fts.createFTSIndex('${e}')`,
          { tableName: e, ftsTableName: n }
        );
      }
      const h = `
        SELECT
          d.id,
          d.doc,
          bm25(${this.escapeIdentifier(n)}) as rank
          ${i?.highlight ? `, snippet(${this.escapeIdentifier(n)}, 2, '<mark>', '</mark>', '...', 32) as snippet` : ""}
        FROM ${this.escapeIdentifier(n)} fts
        JOIN ${this.escapeIdentifier(e)} d ON d.id = fts.doc_id
        WHERE ${this.escapeIdentifier(n)} MATCH ?
        ORDER BY bm25(${this.escapeIdentifier(n)})
        LIMIT ? OFFSET ?
      `;
      return (await this.connection.query(h, [t, s, o])).map((d) => ({
        doc: JSON.parse(d.doc),
        rank: d.rank,
        snippet: d.snippet
      }));
    } catch (n) {
      throw new f(
        `FTS5 search failed: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, query: t, options: i, error: n }
      );
    }
  }
  /**
   * Rebuild FTS index
   */
  async rebuild(e) {
    try {
      const t = `${e}_fts`;
      await this.connection.exec(`DELETE FROM ${this.escapeIdentifier(t)}`), await this.populateFTSIndex(e, t), r.info(`Rebuilt FTS5 index: ${t}`);
    } catch (t) {
      throw new f(
        `Failed to rebuild FTS5 index: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Drop FTS index
   */
  async drop(e) {
    try {
      const t = `${e}_fts`;
      await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_insert`), await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_update`), await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_delete`), await this.connection.exec(`DROP TABLE IF EXISTS ${this.escapeIdentifier(t)}`), r.info(`Dropped FTS5 index: ${t}`);
    } catch (t) {
      throw new f(
        `Failed to drop FTS5 index: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Create triggers to keep FTS index in sync
   */
  async createSyncTriggers(e, t) {
    await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_insert`), await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_update`), await this.connection.exec(`DROP TRIGGER IF EXISTS trg_${e}_fts_delete`);
  }
  /**
   * Populate FTS index with existing documents
   */
  async populateFTSIndex(e, t) {
    try {
      const i = await this.connection.query(
        `SELECT id, doc FROM ${this.escapeIdentifier(e)}`
      );
      if (i.length === 0) {
        r.debug("No documents to index in FTS5");
        return;
      }
      const n = 100;
      r.debug(`Populating FTS5 index with ${i.length} documents in batches of ${n}`);
      for (let s = 0; s < i.length; s += n) {
        const o = i.slice(s, s + n), c = o.map(() => "(?, ?)").join(", "), h = `INSERT INTO ${this.escapeIdentifier(t)} (doc_id, content) VALUES ${c}`, l = [];
        for (const { id: d, doc: g } of o) {
          const w = this.extractTextFromJSON(JSON.parse(g));
          l.push(d, w);
        }
        try {
          await this.connection.exec(h, l), r.debug(`Inserted batch ${Math.floor(s / n) + 1} (${o.length} documents) into FTS index`);
        } catch (d) {
          throw r.error(`Failed to insert batch into FTS index: ${d instanceof Error ? d.message : String(d)}`), d;
        }
      }
      r.debug(`Populated FTS5 index with ${i.length} documents`);
    } catch (i) {
      throw r.warn("Failed to populate FTS5 index", i), i;
    }
  }
  /**
   * Extract text content from JSON for indexing
   */
  extractTextFromJSON(e) {
    return typeof e == "string" ? e : typeof e == "number" || typeof e == "boolean" ? String(e) : e == null ? "" : Array.isArray(e) ? e.map((t) => this.extractTextFromJSON(t)).join(" ") : typeof e == "object" ? Object.values(e).map((t) => this.extractTextFromJSON(t)).join(" ") : "";
  }
  /**
   * Sync a document to FTS index
   */
  async syncDocument(e, t, i) {
    if (!await this.exists(e)) {
      r.debug(`FTS index does not exist for ${e}, skipping sync`);
      return;
    }
    try {
      const s = `${e}_fts`, o = this.extractTextFromJSON(i);
      await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(s)} WHERE doc_id = ?`,
        [t]
      ), await this.connection.exec(
        `INSERT INTO ${this.escapeIdentifier(s)} (doc_id, content) VALUES (?, ?)`,
        [t, o]
      );
    } catch (s) {
      r.warn("Failed to sync document to FTS index", s);
    }
  }
  /**
   * Remove document from FTS index
   */
  async removeDocument(e, t) {
    try {
      const i = `${e}_fts`;
      await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(i)} WHERE doc_id = ?`,
        [t]
      );
    } catch (i) {
      r.warn("Failed to remove document from FTS index", i);
    }
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
}
function ee(a) {
  if (!a || a.length < 3)
    return [];
  const e = [], t = a.toLowerCase().trim();
  for (let i = 0; i <= t.length - 3; i++) {
    const n = t.substring(i, i + 3);
    e.includes(n) || e.push(n);
  }
  return e;
}
class _e {
  constructor(e) {
    this.connection = e;
  }
  /**
   * Escape identifier for SQL
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
  /**
   * Create trigram index table for a JSON table
   */
  async createIndex(e, t) {
    const i = `trigram_${e}_${t.replace(/\./g, "_")}`;
    try {
      await this.connection.exec(`
        CREATE TABLE IF NOT EXISTS ${this.escapeIdentifier(i)} (
          doc_id TEXT NOT NULL,
          trigram TEXT NOT NULL,
          PRIMARY KEY (doc_id, trigram)
        ) WITHOUT ROWID
      `), await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS idx_${i}_trigram 
        ON ${this.escapeIdentifier(i)}(trigram, doc_id)
      `), r.debug(`Created trigram index: ${i} for field: ${t}`);
    } catch (n) {
      throw new f(
        `Failed to create trigram index: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, fieldPath: t, error: n }
      );
    }
  }
  /**
   * Index a document's field value
   */
  async indexDocument(e, t, i, n) {
    const s = `trigram_${e}_${t.replace(/\./g, "_")}`;
    try {
      await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(s)} WHERE doc_id = ?`,
        [i]
      );
      let o = "";
      if (typeof n == "string" ? o = n : n != null && (o = String(n)), !o)
        return;
      const c = ee(o);
      if (c.length === 0)
        return;
      const h = c.map(() => "(?, ?)").join(", "), l = `
        INSERT OR REPLACE INTO ${this.escapeIdentifier(s)} (doc_id, trigram)
        VALUES ${h}
      `, d = [];
      for (const g of c)
        d.push(i, g);
      await this.connection.exec(l, d);
    } catch (o) {
      r.warn(`Failed to index document trigrams: ${o instanceof Error ? o.message : String(o)}`);
    }
  }
  /**
   * Remove document from trigram index
   */
  async removeDocument(e, t, i) {
    const n = `trigram_${e}_${t.replace(/\./g, "_")}`;
    try {
      await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(n)} WHERE doc_id = ?`,
        [i]
      );
    } catch (s) {
      r.warn(`Failed to remove document from trigram index: ${s instanceof Error ? s.message : String(s)}`);
    }
  }
  /**
   * Search for documents matching a partial string
   * 
   * Uses trigram similarity to find documents containing the search term
   */
  async search(e, t, i, n) {
    const s = `trigram_${e}_${t.replace(/\./g, "_")}`, o = n?.limit || 100, c = n?.minSimilarity || 0.3;
    try {
      const h = ee(i);
      if (h.length === 0)
        return [];
      const l = h.map(() => "?").join(", "), d = `
        SELECT 
          doc_id,
          COUNT(DISTINCT trigram) as matching_trigrams,
          ${h.length} as total_search_trigrams
        FROM ${this.escapeIdentifier(s)}
        WHERE trigram IN (${l})
        GROUP BY doc_id
        HAVING (CAST(matching_trigrams AS REAL) / ${h.length}) >= ?
        ORDER BY matching_trigrams DESC
        LIMIT ?
      `, g = [...h, c, o];
      return (await this.connection.query(d, g)).map((T) => ({
        docId: T.doc_id,
        similarity: T.matching_trigrams / T.total_search_trigrams
      }));
    } catch (h) {
      throw new f(
        `Failed to search trigram index: ${h instanceof Error ? h.message : String(h)}`,
        { tableName: e, fieldPath: t, searchTerm: i, error: h }
      );
    }
  }
  /**
   * Drop trigram index
   */
  async dropIndex(e, t) {
    const i = `trigram_${e}_${t.replace(/\./g, "_")}`;
    try {
      await this.connection.exec(`DROP TABLE IF EXISTS ${this.escapeIdentifier(i)}`), r.debug(`Dropped trigram index: ${i}`);
    } catch (n) {
      throw new f(
        `Failed to drop trigram index: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, fieldPath: t, error: n }
      );
    }
  }
  /**
   * Check if trigram index exists
   */
  async exists(e, t) {
    const i = `trigram_${e}_${t.replace(/\./g, "_")}`;
    try {
      return (await this.connection.queryValue(
        "SELECT COUNT(*) FROM sqlite_master WHERE type='table' AND name=?",
        [i]
      ) ?? 0) > 0;
    } catch {
      return !1;
    }
  }
}
class Ae {
  constructor() {
    this.queryTimes = [], this.writeBatches = [], this.indexRebuildTimes = [], this.cacheHits = 0, this.cacheMisses = 0, this.cacheEvictions = 0, this.writeCount = 0, this.writeStartTime = Date.now(), this.indexRebuildCount = 0;
  }
  /**
   * Record a query execution time
   */
  recordQuery(e) {
    this.queryTimes.push(e), this.queryTimes.length > 1e3 && this.queryTimes.shift();
  }
  /**
   * Record a batch write
   */
  recordBatch(e) {
    this.writeBatches.push(e), this.writeCount += e, this.writeBatches.length > 100 && this.writeBatches.shift();
  }
  /**
   * Record cache hit
   */
  recordCacheHit() {
    this.cacheHits++;
  }
  /**
   * Record cache miss
   */
  recordCacheMiss() {
    this.cacheMisses++;
  }
  /**
   * Record cache eviction
   */
  recordCacheEviction() {
    this.cacheEvictions++;
  }
  /**
   * Record index rebuild
   */
  recordIndexRebuild(e) {
    this.indexRebuildCount++, this.indexRebuildTimes.push(e), this.indexRebuildTimes.length > 50 && this.indexRebuildTimes.shift();
  }
  /**
   * Calculate percentile
   */
  percentile(e, t) {
    if (e.length === 0) return 0;
    const i = Math.ceil(t / 100 * e.length) - 1, n = Math.max(0, Math.min(i, e.length - 1));
    return e[n] ?? 0;
  }
  /**
   * Get comprehensive performance metrics
   */
  getMetrics() {
    const e = [...this.queryTimes].sort((d, g) => d - g), t = this.queryTimes.length, i = t > 0 ? this.queryTimes.reduce((d, g) => d + g, 0) / t : 0, n = this.cacheHits + this.cacheMisses, s = n > 0 ? this.cacheHits / n * 100 : 0, o = (Date.now() - this.writeStartTime) / 1e3, c = o > 0 ? this.writeCount / o : 0, h = this.writeBatches.length > 0 ? this.writeBatches.reduce((d, g) => d + g, 0) / this.writeBatches.length : 0, l = this.indexRebuildTimes.length > 0 ? this.indexRebuildTimes.reduce((d, g) => d + g, 0) / this.indexRebuildTimes.length : 0;
    return {
      queries: {
        count: t,
        avgLatency: i,
        p50: this.percentile(e, 50),
        p95: this.percentile(e, 95),
        p99: this.percentile(e, 99),
        min: e.length > 0 ? e[0] ?? 0 : 0,
        max: e.length > 0 ? e[e.length - 1] ?? 0 : 0
      },
      writes: {
        count: this.writeCount,
        throughput: c,
        avgBatchSize: h,
        totalBatches: this.writeBatches.length
      },
      cache: {
        hits: this.cacheHits,
        misses: this.cacheMisses,
        hitRate: s,
        size: 0,
        // Will be set by cache
        maxSize: 0,
        // Will be set by cache
        evictions: this.cacheEvictions
      },
      indexes: {
        rebuildCount: this.indexRebuildCount,
        avgRebuildTime: l
      }
    };
  }
  /**
   * Reset all metrics
   */
  reset() {
    this.queryTimes = [], this.writeBatches = [], this.indexRebuildTimes = [], this.cacheHits = 0, this.cacheMisses = 0, this.cacheEvictions = 0, this.writeCount = 0, this.writeStartTime = Date.now(), this.indexRebuildCount = 0;
  }
}
const $ = new Ae();
class De {
  constructor(e) {
    this.ftsIndexer = null, this.trigramIndexer = null, this.indexQueue = /* @__PURE__ */ new Map(), this.indexDebounceTimer = null, this.cache = null, this.connection = e, this.indexer = new X(e), this.queryBuilder = new re(), this.ftsIndexer = new Oe(e), this.trigramIndexer = new _e(e);
  }
  /**
   * Get trigram indexer
   */
  get trigram() {
    return this.trigramIndexer;
  }
  /**
   * Set cache instance for JSON operations
   */
  setCache(e) {
    this.cache !== e && (r.debug(`JSONTable: Setting cache instance (was: ${this.cache ? "existing" : "null"}, now: ${e ? "new" : "null"})`), this.cache = e);
  }
  /**
   * Sync a document to FTS index without re-inserting
   * Used by batch writer to sync FTS after batch inserts
   */
  async syncFTSDocument(e, t, i) {
    this.ftsIndexer && await this.ftsIndexer.syncDocument(e, t, i).catch((n) => {
      r.warn("FTS sync failed", n);
    });
  }
  /**
   * Create a JSON table
   */
  async createTable(e, t) {
    const i = performance.now();
    try {
      await this.connection.exec(`
        CREATE TABLE IF NOT EXISTS ${this.escapeIdentifier(e)} (
          id TEXT PRIMARY KEY,
          doc TEXT NOT NULL,
          ts INTEGER NOT NULL
        )
      `);
      const n = e.replace(/\./g, "_");
      await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS "${n}_ts" 
        ON ${this.escapeIdentifier(e)}(ts)
      `), await this.indexer.initializeTable(e, t);
      const s = performance.now() - i;
      r.info(`Created JSON table: ${e} in ${s.toFixed(2)}ms`);
    } catch (n) {
      throw new f(
        `Failed to create JSON table: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, options: t, error: n }
      );
    }
  }
  /**
   * Drop a JSON table and its indexes
   */
  async dropTable(e) {
    try {
      await this.indexer.dropTable(e), await this.connection.exec(`DROP TABLE IF EXISTS ${this.escapeIdentifier(e)}`), r.info(`Dropped JSON table: ${e}`);
    } catch (t) {
      throw new f(
        `Failed to drop JSON table: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Store or update a JSON document
   */
  async putDoc(e, t, i) {
    const n = performance.now();
    try {
      const s = JSON.stringify(i), o = Date.now();
      await this.connection.exec(
        `INSERT OR REPLACE INTO ${this.escapeIdentifier(e)} (id, doc, ts) VALUES (?, ?, ?)`,
        [t, s, o]
      ), this.queueIndexUpdate(e, t, i), this.ftsIndexer && await this.ftsIndexer.syncDocument(e, t, i).catch((h) => {
        r.warn("FTS sync failed", h);
      }), this.cache && this.cache.invalidate(`doc:${e}:${t}`);
      const c = performance.now() - n;
      r.debug(`Stored document ${t} in ${e} in ${c.toFixed(2)}ms`);
    } catch (s) {
      throw new f(
        `Failed to store document: ${s instanceof Error ? s.message : String(s)}`,
        { tableName: e, id: t, error: s }
      );
    }
  }
  /**
   * Queue index update (debounced)
   */
  queueIndexUpdate(e, t, i) {
    const n = `${e}:${t}`;
    this.indexQueue.set(n, { docId: t, doc: i }), this.indexDebounceTimer && clearTimeout(this.indexDebounceTimer), this.indexDebounceTimer = setTimeout(async () => {
      await this.flushIndexQueue(e);
    }, 50);
  }
  /**
   * Flush queued index updates
   */
  async flushIndexQueue(e) {
    const t = Array.from(this.indexQueue.entries()).filter(([s]) => s.startsWith(`${e}:`)).map(([, s]) => s);
    if (t.length === 0)
      return;
    for (const [s] of this.indexQueue.entries())
      s.startsWith(`${e}:`) && this.indexQueue.delete(s);
    const i = performance.now();
    for (const { docId: s, doc: o } of t)
      await this.indexer.indexDocument(e, s, o);
    const n = performance.now() - i;
    $.recordIndexRebuild(n), r.debug(`Indexed ${t.length} documents in ${n.toFixed(2)}ms`);
  }
  /**
   * Retrieve a JSON document by ID
   */
  async getDoc(e, t) {
    try {
      const i = `doc:${e}:${t}`;
      if (this.cache) {
        const o = await this.cache.get(i);
        if (o !== null)
          return r.debug(`Cache HIT for key: ${i}`), o;
        r.debug(`Cache MISS for key: ${i} (cache instance exists: ${!!this.cache})`);
      } else
        r.warn(`Cache not available for key: ${i} - cache instance is null!`);
      r.debug(`[JSONTable] Querying DB for key: ${i}, cache exists: ${!!this.cache}`);
      const n = await this.connection.queryOne(
        `SELECT doc FROM ${this.escapeIdentifier(e)} WHERE id = ?`,
        [t]
      );
      if (!n)
        return r.debug(`[JSONTable] No result from DB for key: ${i}`), null;
      const s = JSON.parse(n.doc);
      if (r.debug(`[JSONTable] Parsed doc for key: ${i}, cache exists: ${!!this.cache}`), !this.cache)
        return r.error(`CRITICAL: Cache is NULL when trying to SET key: ${i}! This should never happen.`), s;
      try {
        const o = this.cache.getStats().size;
        r.debug(`[JSONTable] About to SET cache for key: ${i}, size before: ${o}`), this.cache.set(i, s);
        const c = this.cache.getStats().size;
        r.debug(`[JSONTable] Cache SET for key: ${i} (size: ${o} -> ${c})`), await this.cache.get(i) === null ? r.error(`CRITICAL: Cache entry was not stored! Key: ${i}, size after set: ${c}`) : r.debug(`[JSONTable] Cache verification PASSED for key: ${i}`);
      } catch (o) {
        r.error(`Error setting cache for key: ${i}`, o);
      }
      return s;
    } catch (i) {
      throw new f(
        `Failed to retrieve document: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, id: t, error: i }
      );
    }
  }
  /**
   * Find documents matching a filter
   */
  async find(e, t) {
    const i = performance.now();
    try {
      const n = this.queryBuilder.buildFindQuery(e, t), o = (await this.connection.query(n.sql, n.params)).map((h) => JSON.parse(h.doc)), c = performance.now() - i;
      return r.debug(`Found ${o.length} documents in ${e} in ${c.toFixed(2)}ms`), o;
    } catch (n) {
      throw new f(
        `Failed to find documents: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, filter: t, error: n }
      );
    }
  }
  /**
   * Count documents matching a filter
   */
  async count(e, t) {
    try {
      if (!t || Object.keys(t).length === 0)
        return await this.connection.queryValue(
          `SELECT COUNT(*) FROM ${this.escapeIdentifier(e)}`
        ) ?? 0;
      const i = this.queryBuilder.buildCountQuery(e, t);
      return await this.connection.queryValue(i.sql, i.params) ?? 0;
    } catch (i) {
      throw new f(
        `Failed to count documents: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, filter: t, error: i }
      );
    }
  }
  /**
   * Delete a document by ID
   */
  async deleteDoc(e, t) {
    try {
      await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(e)} WHERE id = ?`,
        [t]
      ), await this.indexer.removeDocument(e, t), this.ftsIndexer && await this.ftsIndexer.removeDocument(e, t).catch((i) => {
        r.warn("FTS removal failed", i);
      }), this.cache && this.cache.invalidate(`doc:${e}:${t}`), this.indexQueue.delete(`${e}:${t}`), r.debug(`Deleted document ${t} from ${e}`);
    } catch (i) {
      throw new f(
        `Failed to delete document: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, id: t, error: i }
      );
    }
  }
  /**
   * Get FTS indexer
   */
  get fts() {
    return this.ftsIndexer;
  }
  /**
   * Rebuild indexes for a table
   */
  async rebuildIndexes(e) {
    try {
      await this.indexer.rebuildIndexes(e), r.info(`Rebuilt indexes for ${e}`);
    } catch (t) {
      throw new f(
        `Failed to rebuild indexes: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Get table metadata
   */
  async getMetadata(e) {
    try {
      const t = await this.count(e), i = await this.indexer.getIndexedKeys(e);
      return {
        tableName: e,
        documentCount: t,
        indexedKeys: i
      };
    } catch (t) {
      throw new f(
        `Failed to get metadata: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
}
class ve {
  constructor(e) {
    this.connection = e, this.queryBuilder = new re();
  }
  /**
   * Create a temporary view from a JSON table query
   * 
   * @param viewName Name for the temporary view
   * @param jsonTable JSON table name
   * @param filter Optional filter for JSON documents
   * @param columns Columns to extract from JSON (default: all)
   * @returns View name that can be used in JOINs
   */
  async createViewFromJSON(e, t, i, n) {
    try {
      const s = this.queryBuilder.buildFindQuery(t, i || {}), o = n && n.length > 0 ? n.map((h) => `json_extract(doc, '$.${this.normalizeKeyPath(h)}') AS ${this.escapeIdentifier(h)}`).join(", ") : "doc AS doc, id AS id, ts AS ts", c = `
        CREATE TEMPORARY VIEW ${this.escapeIdentifier(e)} AS
        SELECT ${o}, id AS json_id, ts AS json_ts
        FROM (${s.sql})
      `;
      return await this.connection.exec(c, s.params), r.debug(`Created temporary view: ${e} from JSON table: ${t}`), e;
    } catch (s) {
      throw new f(
        `Failed to create view from JSON: ${s instanceof Error ? s.message : String(s)}`,
        { viewName: e, jsonTable: t, filter: i, columns: n, error: s }
      );
    }
  }
  /**
   * Execute a hybrid query (JOIN JSON table with SQL table)
   * 
   * @param sqlTable SQL table name
   * @param jsonTable JSON table name
   * @param joinCondition JOIN condition (e.g., "sql_table.id = json_table.userId")
   * @param jsonFilter Optional filter for JSON documents
   * @param selectColumns Columns to select from both tables
   * @param whereClause Optional WHERE clause for SQL table
   * @returns Query result
   */
  async joinJSONWithSQL(e) {
    const {
      sqlTable: t,
      jsonTable: i,
      joinCondition: n,
      jsonFilter: s,
      selectColumns: o,
      whereClause: c,
      orderBy: h,
      limit: l
    } = e;
    try {
      const d = `json_view_${Date.now()}`;
      await this.createViewFromJSON(d, i, s, o);
      let w = `
        SELECT ${o && o.length > 0 ? o.map((m) => `${this.escapeIdentifier(t)}.${this.escapeIdentifier(m)}, ${this.escapeIdentifier(d)}.${this.escapeIdentifier(m)} AS json_${m}`).join(", ") : `${this.escapeIdentifier(t)}.*, ${this.escapeIdentifier(d)}.doc AS json_doc, ${this.escapeIdentifier(d)}.json_id, ${this.escapeIdentifier(d)}.json_ts`}
        FROM ${this.escapeIdentifier(t)}
        INNER JOIN ${this.escapeIdentifier(d)} ON ${n}
      `;
      c && (w += ` WHERE ${c}`), h && (w += ` ORDER BY ${h}`), l && (w += ` LIMIT ${l}`);
      const T = await this.connection.query(w);
      return await this.connection.exec(`DROP VIEW IF EXISTS ${this.escapeIdentifier(d)}`), T;
    } catch (d) {
      throw new f(
        `Failed to execute hybrid query: ${d instanceof Error ? d.message : String(d)}`,
        { options: e, error: d }
      );
    }
  }
  /**
   * Execute a hybrid query with JSON documents filtered by SQL table
   * 
   * This is the reverse: start with SQL table, filter JSON documents
   */
  async joinSQLWithJSON(e) {
    return this.joinJSONWithSQL({
      sqlTable: e.sqlTable,
      jsonTable: e.jsonTable,
      joinCondition: e.joinCondition,
      jsonFilter: e.jsonFilter,
      selectColumns: e.selectColumns,
      whereClause: e.sqlWhere,
      orderBy: e.orderBy,
      limit: e.limit
    });
  }
  /**
   * Normalize key path for JSON extraction
   */
  normalizeKeyPath(e) {
    return e.replace(/\./g, ".");
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
}
async function Je(a, e, t) {
  await a.exec(`
    CREATE TABLE IF NOT EXISTS ${O(e)} (
      id TEXT PRIMARY KEY,
      doc TEXT NOT NULL,
      ts INTEGER NOT NULL
    )
  `), await a.exec(`
    CREATE INDEX IF NOT EXISTS idx_${e}_ts 
    ON ${O(e)}(ts)
  `), await a.exec(`
    CREATE TABLE IF NOT EXISTS ${O(`json_keys_${e}`)} (
      table_name TEXT NOT NULL,
      key_path TEXT NOT NULL,
      doc_id TEXT NOT NULL,
      PRIMARY KEY (table_name, key_path, doc_id)
    )
  `), await a.exec(`
    CREATE INDEX IF NOT EXISTS idx_${e}_keys_path 
    ON ${O(`json_keys_${e}`)}(key_path, doc_id)
  `), await a.exec(`
    CREATE TABLE IF NOT EXISTS ${O(`json_values_${e}`)} (
      table_name TEXT NOT NULL,
      key_path TEXT NOT NULL,
      value_hash TEXT,
      doc_id TEXT NOT NULL,
      value_text TEXT,
      value_type TEXT,
      PRIMARY KEY (table_name, key_path, doc_id, value_hash)
    )
  `), await a.exec(`
    CREATE INDEX IF NOT EXISTS idx_${e}_values_key 
    ON ${O(`json_values_${e}`)}(key_path, value_hash)
  `), await a.exec(`
    CREATE INDEX IF NOT EXISTS idx_${e}_values_text 
    ON ${O(`json_values_${e}`)}(key_path, value_text)
  `);
}
async function Ge(a, e) {
  await a.exec(`DROP TABLE IF EXISTS ${O(`json_keys_${e}`)}`), await a.exec(`DROP TABLE IF EXISTS ${O(`json_values_${e}`)}`), await a.exec(`DROP TABLE IF EXISTS ${O(e)}`);
}
function O(a) {
  return `"${a.replace(/"/g, '""')}"`;
}
const Ce = {
  maxSize: 100,
  timeout: 100,
  autoFlush: !0
};
class Fe {
  constructor(e, t) {
    this.queue = [], this.flushTimer = null, this.isFlushing = !1, this.stats = {
      totalBatches: 0,
      totalOperations: 0,
      avgBatchSize: 0
    }, this.jsonTable = null, this.connection = e, this.options = { ...Ce, ...t };
  }
  /**
   * Set JSON table reference for FTS sync after batch writes
   */
  setJSONTable(e) {
    this.jsonTable = e;
  }
  /**
   * Add a write operation to the batch queue
   */
  async add(e) {
    if (this.queue.push(e), this.stats.totalOperations++, this.options.autoFlush && this.queue.length >= this.options.maxSize) {
      await this.flush();
      return;
    }
    !this.flushTimer && this.queue.length > 0 && (this.flushTimer = setTimeout(() => {
      this.flush().catch((t) => {
        r.error("Batch flush error", t);
      });
    }, this.options.timeout));
  }
  /**
   * Flush all queued operations
   */
  async flush() {
    if (this.isFlushing || this.queue.length === 0)
      return;
    this.isFlushing = !0, this.flushTimer && (clearTimeout(this.flushTimer), this.flushTimer = null);
    const e = this.queue.splice(0), t = performance.now();
    if (r.debug(`Batch: Starting flush with ${e.length} operations`), e.length === 0) {
      r.warn("Batch: Flush called but queue is empty!");
      return;
    }
    try {
      await this.connection.transaction(async () => {
        r.debug(`Batch: Transaction started, executing ${e.length} operations`);
        const n = this.connection.getEngine();
        for (let s = 0; s < e.length; s++) {
          const o = e[s];
          if (!o) {
            r.error(`Batch: Operation ${s + 1} is undefined!`);
            continue;
          }
          try {
            r.debug(`Batch: Executing operation ${s + 1}/${e.length}: ${o.type} on ${o.table || "unknown"} (id: ${o.id || "N/A"})`), r.debug(`Batch: SQL: ${o.sql.substring(0, 100)}${o.sql.length > 100 ? "..." : ""}, params: ${JSON.stringify(o.params)}`);
            const c = performance.now();
            await n.exec(o.sql, o.params);
            const h = performance.now() - c;
            r.debug(`Batch: Successfully executed operation ${s + 1}/${e.length} in ${h.toFixed(2)}ms`);
          } catch (c) {
            throw r.error(`Batch: Failed to execute operation ${s + 1}/${e.length} (${o.type} on ${o.table || "unknown"}): ${c instanceof Error ? c.message : String(c)}`, c), c;
          }
        }
        r.debug(`Batch: All ${e.length} operations executed, committing transaction`);
      }), r.debug(`Batch: Successfully flushed ${e.length} operations`);
      const i = performance.now() - t;
      if (this.stats.totalBatches++, this.stats.avgBatchSize = (this.stats.avgBatchSize * (this.stats.totalBatches - 1) + e.length) / this.stats.totalBatches, $.recordBatch(e.length), this.jsonTable) {
        for (const n of e)
          if ((n.type === "insert" || n.type === "update") && n.table && n.id)
            try {
              if (n.params && n.params.length >= 2) {
                const s = n.params[1];
                if (typeof s == "string") {
                  const o = JSON.parse(s);
                  typeof this.jsonTable.syncFTSDocument == "function" && await this.jsonTable.syncFTSDocument(n.table, n.id, o).catch(() => {
                  });
                }
              }
            } catch (s) {
              r.debug("Skipping FTS sync for batch operation", s);
            }
      }
      r.debug(
        `Flushed batch: ${e.length} operations in ${i.toFixed(2)}ms`
      );
    } catch (i) {
      throw r.error(`Batch flush failed: ${i instanceof Error ? i.message : String(i)}`, i), r.error(`Failed operations: ${e.length} operations were not executed`), i;
    } finally {
      this.isFlushing = !1;
    }
  }
  /**
   * Get current queue size
   */
  getQueueSize() {
    return this.queue.length;
  }
  /**
   * Get batch statistics
   */
  getStats() {
    return {
      ...this.stats,
      queueSize: this.queue.length,
      isFlushing: this.isFlushing
    };
  }
  /**
   * Reset statistics
   */
  resetStats() {
    this.stats = {
      totalBatches: 0,
      totalOperations: 0,
      avgBatchSize: 0
    };
  }
  /**
   * Update batch options
   */
  updateOptions(e) {
    this.options = { ...this.options, ...e };
  }
}
const Ne = "hunidb_cache", S = "cache_entries", Le = 1;
class ze {
  constructor() {
    this.db = null, this.isInitialized = !1, this.initPromise = null;
  }
  /**
   * Initialize IndexedDB connection
   */
  async initialize() {
    if (!(this.isInitialized && this.db))
      return this.initPromise ? this.initPromise : (this.initPromise = new Promise((e, t) => {
        if (typeof indexedDB > "u" || !indexedDB) {
          r.warn("IndexedDB not available, shadow cache disabled"), this.isInitialized = !0, e();
          return;
        }
        const i = indexedDB.open(Ne, Le);
        i.onerror = () => {
          r.error("Failed to open IndexedDB for shadow cache", i.error), this.initPromise = null, t(i.error);
        }, i.onsuccess = () => {
          this.db = i.result, this.isInitialized = !0, r.debug("IndexedDB shadow cache initialized"), this.initPromise = null, e();
        }, i.onupgradeneeded = (n) => {
          const s = n.target.result;
          s.objectStoreNames.contains(S) || (s.createObjectStore(S, { keyPath: "key" }).createIndex("timestamp", "timestamp", { unique: !1 }), r.debug("Created IndexedDB object store for shadow cache"));
        };
      }), this.initPromise);
  }
  /**
   * Get value from IndexedDB
   */
  async get(e) {
    return this.isInitialized || await this.initialize(), this.db ? new Promise((t, i) => {
      const o = this.db.transaction([S], "readonly").objectStore(S).get(e);
      o.onerror = () => {
        r.error("Failed to get from IndexedDB shadow cache", o.error), i(o.error);
      }, o.onsuccess = () => {
        const c = o.result;
        c && c.entry ? t(c.entry.value) : t(null);
      };
    }) : null;
  }
  /**
   * Set value in IndexedDB
   */
  async set(e, t) {
    if (this.isInitialized || await this.initialize(), !!this.db)
      return new Promise((i, n) => {
        const c = this.db.transaction([S], "readwrite").objectStore(S).put({
          key: e,
          entry: t,
          timestamp: Date.now()
        });
        c.onerror = () => {
          r.error("Failed to set in IndexedDB shadow cache", c.error), n(c.error);
        }, c.onsuccess = () => {
          i();
        };
      });
  }
  /**
   * Delete value from IndexedDB
   */
  async delete(e) {
    if (this.isInitialized || await this.initialize(), !!this.db)
      return new Promise((t, i) => {
        const o = this.db.transaction([S], "readwrite").objectStore(S).delete(e);
        o.onerror = () => {
          r.error("Failed to delete from IndexedDB shadow cache", o.error), i(o.error);
        }, o.onsuccess = () => {
          t();
        };
      });
  }
  /**
   * Clear all entries from IndexedDB
   */
  async clear() {
    if (this.isInitialized || await this.initialize(), !!this.db)
      return new Promise((e, t) => {
        const s = this.db.transaction([S], "readwrite").objectStore(S).clear();
        s.onerror = () => {
          r.error("Failed to clear IndexedDB shadow cache", s.error), t(s.error);
        }, s.onsuccess = () => {
          r.debug("Cleared IndexedDB shadow cache"), e();
        };
      });
  }
  /**
   * Get all keys from IndexedDB
   */
  async getAllKeys() {
    return this.isInitialized || await this.initialize(), this.db ? new Promise((e, t) => {
      const s = this.db.transaction([S], "readonly").objectStore(S).getAllKeys();
      s.onerror = () => {
        r.error("Failed to get keys from IndexedDB shadow cache", s.error), t(s.error);
      }, s.onsuccess = () => {
        e(s.result);
      };
    }) : [];
  }
  /**
   * Check if IndexedDB is available
   */
  isAvailable() {
    return typeof indexedDB < "u" && indexedDB !== null;
  }
  /**
   * Close IndexedDB connection
   */
  close() {
    this.db && (this.db.close(), this.db = null, this.isInitialized = !1, r.debug("Closed IndexedDB shadow cache connection"));
  }
}
const Be = {
  maxSize: 1e3,
  persistent: !1
};
class te {
  constructor(e) {
    this.cache = /* @__PURE__ */ new Map(), this.shadow = null, this.stats = {
      hits: 0,
      misses: 0,
      evictions: 0
    }, this.options = { ...Be, ...e }, this.options.persistent && (this.shadow = new ze(), this.shadow.initialize().catch((t) => {
      r.warn("Failed to initialize IndexedDB shadow cache", t), this.shadow = null;
    }));
  }
  /**
   * Get value from cache
   */
  async get(e) {
    const t = this.cache.get(e);
    if (t)
      return this.options.ttl && Date.now() - t.timestamp > this.options.ttl ? (this.cache.delete(e), this.shadow && this.shadow.delete(e).catch(() => {
      }), this.stats.misses++, $.recordCacheMiss(), r.debug(`Cache MISS (expired): ${e}`), null) : (t.lastAccess = Date.now(), t.accessCount++, this.cache.delete(e), this.cache.set(e, t), this.stats.hits++, $.recordCacheHit(), r.debug(`Cache HIT: ${e} (cache size: ${this.cache.size}, hits: ${this.stats.hits}, misses: ${this.stats.misses})`), t.value);
    if (this.shadow)
      try {
        const i = await this.shadow.get(e);
        if (i)
          return this.options.ttl && Date.now() - i.timestamp > this.options.ttl ? (await this.shadow.delete(e).catch(() => {
          }), this.stats.misses++, $.recordCacheMiss(), r.debug(`Cache MISS (shadow expired): ${e}`), null) : (this.cache.set(e, i), this.stats.hits++, $.recordCacheHit(), r.debug(`Cache HIT (from shadow): ${e}`), i.value);
      } catch (i) {
        r.debug("Failed to get from shadow cache", i);
      }
    return this.stats.misses++, $.recordCacheMiss(), r.debug(`Cache MISS: ${e} (cache size: ${this.cache.size})`), null;
  }
  /**
   * Set value in cache
   */
  set(e, t) {
    this.cache.has(e) && this.cache.delete(e), this.cache.size >= this.options.maxSize && this.evictLRU();
    const i = {
      value: t,
      timestamp: Date.now(),
      accessCount: 0,
      lastAccess: Date.now()
    };
    this.cache.set(e, i), r.debug(`Cache SET: ${e} (cache size: ${this.cache.size}/${this.options.maxSize})`), this.shadow && this.shadow.set(e, i).catch((n) => {
      r.debug("Failed to set in shadow cache", n);
    });
  }
  /**
   * Invalidate a cache entry
   */
  invalidate(e) {
    this.cache.delete(e), this.shadow && this.shadow.delete(e).catch((t) => {
      r.debug("Failed to delete from shadow cache", t);
    });
  }
  /**
   * Invalidate entries matching a pattern
   */
  invalidatePattern(e) {
    const t = typeof e == "string" ? new RegExp(e.replace(/\*/g, ".*")) : e;
    for (const i of this.cache.keys())
      t.test(i) && this.cache.delete(i);
  }
  /**
   * Clear all cache entries
   */
  async clear() {
    this.cache.clear(), this.shadow && await this.shadow.clear().catch((e) => {
      r.debug("Failed to clear shadow cache", e);
    }), r.debug(`Cache cleared (size was: ${this.cache.size}, stats preserved)`);
  }
  /**
   * Evict least recently used entry
   */
  evictLRU() {
    if (this.cache.size === 0)
      return;
    let e = null, t = 1 / 0;
    for (const [i, n] of this.cache.entries())
      n.lastAccess < t && (t = n.lastAccess, e = i);
    e && (this.cache.delete(e), this.stats.evictions++, $.recordCacheEviction());
  }
  /**
   * Get cache statistics
   */
  getStats() {
    const e = this.stats.hits + this.stats.misses, t = e > 0 ? this.stats.hits / e * 100 : 0;
    return {
      size: this.cache.size,
      maxSize: this.options.maxSize,
      hits: this.stats.hits,
      misses: this.stats.misses,
      hitRate: t,
      evictions: this.stats.evictions
    };
  }
  /**
   * Reset statistics
   */
  resetStats() {
    this.stats = {
      hits: 0,
      misses: 0,
      evictions: 0
    };
  }
  /**
   * Get cache size
   */
  getSize() {
    return this.cache.size;
  }
  /**
   * Check if key exists
   */
  has(e) {
    return this.cache.has(e);
  }
}
class Me {
  constructor(e, t) {
    this.connection = e, this.options = {
      chunkSize: t.chunkSize || 1e3,
      valueType: t.valueType || "REAL",
      partitionBy: t.partitionBy,
      retentionDays: t.retentionDays,
      compress: t.compress || !1
    };
  }
  /**
   * Create a time-series table with optimized structure
   */
  async createTable(e) {
    try {
      await this.connection.exec(`
        CREATE TABLE IF NOT EXISTS ${this.escapeIdentifier(e)} (
          timestamp INTEGER NOT NULL,
          value ${this.options.valueType} NOT NULL,
          tags TEXT,  -- JSON string for tags
          PRIMARY KEY (timestamp, value)
        ) WITHOUT ROWID
      `);
      const t = e.replace(/\./g, "_"), i = `idx_${t}_timestamp`;
      if (await this.connection.exec(`
        CREATE INDEX IF NOT EXISTS ${this.escapeIdentifier(i)} 
        ON ${this.escapeIdentifier(e)}(timestamp DESC)
      `), this.options.partitionBy) {
        const n = `idx_${t}_tags`;
        await this.connection.exec(`
          CREATE INDEX IF NOT EXISTS ${this.escapeIdentifier(n)} 
          ON ${this.escapeIdentifier(e)}(tags)
        `);
      }
      r.info(`Created time-series table: ${e}`);
    } catch (t) {
      throw new f(
        `Failed to create time-series table: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Bulk insert time-series points (optimized)
   */
  async bulkInsert(e, t) {
    const i = performance.now();
    try {
      if (t.length === 0)
        return { inserted: 0, duration: 0, throughput: 0 };
      const n = [...t].sort((d, g) => d.timestamp - g.timestamp), s = this.chunkArray(n, this.options.chunkSize);
      let o = 0;
      const c = this.connection.getEngine();
      await this.connection.transaction(async () => {
        for (const d of s) {
          const g = [];
          for (const p of d) {
            let u;
            if (typeof p.value == "number" && !isNaN(p.value) && isFinite(p.value) ? u = p.value : typeof p.value == "object" ? u = parseFloat(JSON.stringify(p.value)) || 0 : u = parseFloat(String(p.value)) || 0, u == null || isNaN(u) || !isFinite(u)) {
              r.warn(`Skipping invalid time-series point: ${JSON.stringify(p)}`);
              continue;
            }
            g.push({
              ...p,
              value: u
            });
          }
          if (g.length === 0) continue;
          const w = g.map(() => "(?, ?, ?)").join(", "), T = `
            INSERT OR REPLACE INTO ${this.escapeIdentifier(e)} 
            (timestamp, value, tags) 
            VALUES ${w}
          `, m = [];
          for (const p of g)
            m.push(
              p.timestamp,
              p.value,
              p.tags ? JSON.stringify(p.tags) : null
            );
          await c.exec(T, m), o += g.length;
        }
      });
      const h = performance.now() - i, l = o / h * 1e3;
      return $.recordBatch(o), r.debug(
        `Bulk inserted ${o} points in ${h.toFixed(2)}ms (${l.toFixed(0)} pts/sec)`
      ), {
        inserted: o,
        duration: h,
        throughput: l
      };
    } catch (n) {
      throw new f(
        `Failed to bulk insert: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, pointCount: t.length, error: n }
      );
    }
  }
  /**
   * Query time-series data by time range
   */
  async queryRange(e, t) {
    const i = performance.now();
    try {
      let n = `
        SELECT timestamp, value, tags 
        FROM ${this.escapeIdentifier(e)}
        WHERE timestamp >= ? AND timestamp <= ?
      `;
      const s = [t.startTime, t.endTime];
      if (t.tags && Object.keys(t.tags).length > 0)
        for (const [l, d] of Object.entries(t.tags))
          n += ` AND json_extract(tags, '$.${l}') = ?`, s.push(d);
      n += ` ORDER BY timestamp ${t.orderBy || "ASC"}`, t.limit && (n += " LIMIT ?", s.push(t.limit)), t.offset && (n += " OFFSET ?", s.push(t.offset));
      const c = (await this.connection.query(n, s)).map((l) => {
        let d;
        try {
          d = JSON.parse(l.value);
        } catch {
          d = l.value;
        }
        return {
          timestamp: l.timestamp,
          value: d,
          tags: l.tags ? JSON.parse(l.tags) : void 0
        };
      }), h = performance.now() - i;
      return r.debug(`Query returned ${c.length} points in ${h.toFixed(2)}ms`), c;
    } catch (n) {
      throw new f(
        `Failed to query time-series: ${n instanceof Error ? n.message : String(n)}`,
        { tableName: e, query: t, error: n }
      );
    }
  }
  /**
   * Get aggregated data (downsampling)
   */
  async aggregate(e, t) {
    if (!t.aggregation)
      throw new f("Aggregation function and interval required");
    try {
      const { function: i, interval: n } = t.aggregation, s = ["AVG", "SUM", "MIN", "MAX", "COUNT"], o = String(i).toUpperCase();
      if (!s.includes(o))
        throw new f(
          `Invalid aggregation function: ${i}. Allowed: ${s.join(", ")}`
        );
      const c = Number(n);
      if (!Number.isFinite(c) || c <= 0)
        throw new f(`Invalid aggregation interval: ${n}`);
      let h = `
        SELECT 
          (timestamp / ${c}) * ${c} as bucket,
          ${o}(CAST(value AS REAL)) as value
        FROM ${this.escapeIdentifier(e)}
        WHERE timestamp >= ? AND timestamp <= ?
      `;
      const l = [t.startTime, t.endTime];
      if (t.tags && Object.keys(t.tags).length > 0)
        for (const [g, w] of Object.entries(t.tags))
          h += ` AND json_extract(tags, '$.${g}') = ?`, l.push(w);
      return h += `
        GROUP BY bucket
        ORDER BY bucket ASC
      `, (await this.connection.query(h, l)).map((g) => ({
        timestamp: g.bucket,
        value: g.value
      }));
    } catch (i) {
      throw new f(
        `Failed to aggregate: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, query: t, error: i }
      );
    }
  }
  /**
   * Delete old data (retention policy)
   */
  async deleteOld(e, t) {
    try {
      const n = await this.connection.queryValue(
        `SELECT COUNT(*) FROM ${this.escapeIdentifier(e)} WHERE timestamp < ?`,
        [t]
      ) ?? 0;
      return n > 0 && (await this.connection.exec(
        `DELETE FROM ${this.escapeIdentifier(e)} WHERE timestamp < ?`,
        [t]
      ), r.info(`Deleted ${n} old time-series points`)), n;
    } catch (i) {
      throw new f(
        `Failed to delete old data: ${i instanceof Error ? i.message : String(i)}`,
        { tableName: e, beforeTimestamp: t, error: i }
      );
    }
  }
  /**
   * Get time-series statistics
   */
  async getStats(e) {
    try {
      const t = await this.connection.queryOne(
        `SELECT 
          COUNT(*) as count,
          MIN(timestamp) as min_ts,
          MAX(timestamp) as max_ts
        FROM ${this.escapeIdentifier(e)}`
      );
      if (!t)
        return {
          tableName: e,
          pointCount: 0,
          oldestTimestamp: null,
          newestTimestamp: null,
          timeSpan: null,
          partitions: []
        };
      const i = t.max_ts && t.min_ts ? t.max_ts - t.min_ts : null;
      return {
        tableName: e,
        pointCount: t.count,
        oldestTimestamp: t.min_ts || null,
        newestTimestamp: t.max_ts || null,
        timeSpan: i,
        partitions: []
        // TODO: Implement partitioning
      };
    } catch (t) {
      throw new f(
        `Failed to get stats: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Drop time-series table
   */
  async dropTable(e) {
    try {
      await this.connection.exec(`DROP TABLE IF EXISTS ${this.escapeIdentifier(e)}`), r.info(`Dropped time-series table: ${e}`);
    } catch (t) {
      throw new f(
        `Failed to drop table: ${t instanceof Error ? t.message : String(t)}`,
        { tableName: e, error: t }
      );
    }
  }
  /**
   * Chunk array into smaller arrays
   */
  chunkArray(e, t) {
    const i = [];
    for (let n = 0; n < e.length; n += t)
      i.push(e.slice(n, n + t));
    return i;
  }
  /**
   * Escape SQL identifier
   */
  escapeIdentifier(e) {
    return `"${e.replace(/"/g, '""')}"`;
  }
}
function Ye(a, e, t) {
  return ke(a), qe(e), t?.indexes && Pe(t.indexes, e), {
    name: a,
    columns: e,
    options: t
  };
}
function Ze(a) {
  return a;
}
function et(a, e, t) {
  if (!a || typeof a != "string")
    throw new b("Index name must be a non-empty string");
  if (!Array.isArray(e) || e.length === 0)
    throw new b("Index must have at least one column");
  return {
    name: a,
    columns: e,
    ...t
  };
}
function tt(a) {
  const e = [], t = A(a.name);
  for (const [n, s] of Object.entries(a.columns)) {
    const o = [A(n), s.type];
    if (s.primaryKey && (o.push("PRIMARY KEY"), s.autoIncrement && o.push("AUTOINCREMENT")), s.notNull && !s.primaryKey && o.push("NOT NULL"), s.unique && !s.primaryKey && o.push("UNIQUE"), s.default !== void 0 && o.push(`DEFAULT ${Ue(s.default)}`), s.check && o.push(`CHECK (${s.check})`), s.references) {
      const [c, h] = s.references.split(".");
      c && h && o.push(`REFERENCES ${A(c)}(${A(h)})`), s.onDelete && o.push(`ON DELETE ${s.onDelete}`), s.onUpdate && o.push(`ON UPDATE ${s.onUpdate}`);
    }
    e.push(o.join(" "));
  }
  let i = `CREATE TABLE ${t} (
  ${e.join(`,
  `)}
)`;
  return a.options?.withoutRowId && (i += " WITHOUT ROWID"), a.options?.strict && (i += " STRICT"), i;
}
function it(a, e) {
  const t = A(e.name), i = A(a), n = e.columns.map((o) => A(o)).join(", ");
  let s = `CREATE ${e.unique ? "UNIQUE " : ""}INDEX ${t} ON ${i}(${n})`;
  return e.where && (s += ` WHERE ${e.where}`), s;
}
function nt(a) {
  return `DROP TABLE IF EXISTS ${A(a)}`;
}
function st(a) {
  return `DROP INDEX IF EXISTS ${A(a)}`;
}
function ke(a) {
  if (!a || typeof a != "string")
    throw new b("Table name must be a non-empty string");
  if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(a))
    throw new b(`Invalid table name: ${a}. Must start with letter or underscore and contain only alphanumeric characters and underscores`);
  if (["SELECT", "FROM", "WHERE", "INSERT", "UPDATE", "DELETE", "CREATE", "DROP", "TABLE", "INDEX"].includes(a.toUpperCase()))
    throw new b(`Table name cannot be a SQL reserved word: ${a}`);
}
function qe(a) {
  if (Object.keys(a).length === 0)
    throw new b("Table must have at least one column");
  let t = !1;
  for (const [i, n] of Object.entries(a)) {
    if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(i))
      throw new b(`Invalid column name: ${i}`);
    if (!["TEXT", "INTEGER", "REAL", "BLOB", "NULL", "JSON"].includes(n.type))
      throw new b(`Invalid data type for column ${i}: ${n.type}`);
    if (n.primaryKey) {
      if (t)
        throw new b("Table can only have one primary key column (composite keys not yet supported)");
      if (t = !0, n.autoIncrement && n.type !== "INTEGER")
        throw new b(`AUTOINCREMENT can only be used with INTEGER PRIMARY KEY on column ${i}`);
    }
    if (n.references && !/^[a-zA-Z_][a-zA-Z0-9_]*\.[a-zA-Z_][a-zA-Z0-9_]*$/.test(n.references))
      throw new b(`Invalid foreign key reference format for column ${i}: ${n.references}. Expected format: table.column`);
  }
}
function Pe(a, e) {
  const t = /* @__PURE__ */ new Set(), i = Object.keys(e);
  for (const n of a) {
    if (t.has(n.name))
      throw new b(`Duplicate index name: ${n.name}`);
    if (t.add(n.name), !/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(n.name))
      throw new b(`Invalid index name: ${n.name}`);
    for (const s of n.columns)
      if (!i.includes(s))
        throw new b(`Index ${n.name} references non-existent column: ${s}`);
  }
}
function A(a) {
  return `"${a.replace(/"/g, '""')}"`;
}
function Ue(a) {
  return a == null ? "NULL" : typeof a == "string" ? `'${a.replace(/'/g, "''")}'` : typeof a == "number" || typeof a == "boolean" ? String(a) : typeof a == "object" ? `'${JSON.stringify(a).replace(/'/g, "''")}'` : String(a);
}
function rt(a) {
  const { table: e, columns: t, where: i, orderBy: n, limit: s, offset: o } = a;
  let c = `SELECT ${t ? t.join(", ") : "*"} FROM "${e}"`;
  const h = [];
  if (i && Object.keys(i).length > 0) {
    const l = Object.keys(i).map((d) => `"${d}" = ?`);
    c += ` WHERE ${l.join(" AND ")}`, h.push(...Object.values(i));
  }
  return n && (c += ` ORDER BY ${n}`), s !== void 0 && (c += " LIMIT ?", h.push(s)), o !== void 0 && (c += " OFFSET ?", h.push(o)), { sql: c, params: h };
}
function at(a, e) {
  const t = Object.keys(e), i = t.map(() => "?").join(", "), n = t.map((c) => `"${c}"`).join(", "), s = `INSERT INTO "${a}" (${n}) VALUES (${i})`, o = Object.values(e);
  return { sql: s, params: o };
}
function ot(a, e, t) {
  const i = Object.keys(e).map((c) => `"${c}" = ?`), n = Object.keys(t).map((c) => `"${c}" = ?`), s = `UPDATE "${a}" SET ${i.join(", ")} WHERE ${n.join(" AND ")}`, o = [...Object.values(e), ...Object.values(t)];
  return { sql: s, params: o };
}
function ct(a, e) {
  const t = Object.keys(e).map((s) => `"${s}" = ?`), i = `DELETE FROM "${a}" WHERE ${t.join(" AND ")}`, n = Object.values(e);
  return { sql: i, params: n };
}
function ht(a, e) {
  let t = `SELECT COUNT(*) as count FROM "${a}"`;
  const i = [];
  if (e && Object.keys(e).length > 0) {
    const n = Object.keys(e).map((s) => `"${s}" = ?`);
    t += ` WHERE ${n.join(" AND ")}`, i.push(...Object.values(e));
  }
  return { sql: t, params: i };
}
function lt(a) {
  return `"${a.replace(/"/g, '""')}"`;
}
function dt(a) {
  return a == null ? "NULL" : typeof a == "string" ? `'${a.replace(/'/g, "''")}'` : typeof a == "number" || typeof a == "boolean" ? String(a) : a instanceof Date ? String(a.getTime()) : typeof a == "object" ? `'${JSON.stringify(a).replace(/'/g, "''")}'` : String(a);
}
function ut(a, e) {
  const t = e.map(() => "?").join(", ");
  return { sql: `"${a}" IN (${t})`, params: e };
}
function ft(a, e, t) {
  return { sql: `"${a}" BETWEEN ? AND ?`, params: [e, t] };
}
function gt(a) {
  return a.filter((e) => e.trim()).join(" AND ");
}
function mt(a) {
  const { page: e, pageSize: t } = a;
  return {
    limit: t,
    offset: (e - 1) * t
  };
}
class je {
  constructor(e) {
    this._json = null, this._batch = null, this._cache = null, this.connection = e, this.dbName = e.getDatabaseName();
  }
  /**
   * JSON table operations
   */
  get json() {
    return this._json || (this._json = new De(this.connection)), this._cache || (this._cache = new te(), r.debug("Database: Created new HotCache instance in json getter")), this._json.setCache(this._cache), this._batch && !this._batch.jsonTable && this._batch.setJSONTable(this._json), this._json;
  }
  /**
   * Hybrid query builder (JSON + SQL JOINs)
   */
  get hybrid() {
    return new ve(this.connection);
  }
  /**
   * Trigram indexer for partial string matching
   */
  get trigram() {
    return this.json.trigram;
  }
  /**
   * Create a time-series table manager
   */
  timeseries(e) {
    return new Me(this.connection, e);
  }
  /**
   * Batch writer for optimized writes
   */
  get batch() {
    return this._batch || (this._batch = new Fe(this.connection), this._json && this._batch.setJSONTable(this._json)), this._json && !this._batch.jsonTable && this._batch.setJSONTable(this._json), this._batch;
  }
  /**
   * Hot KV cache for frequent reads
   */
  get cache() {
    return this._cache || (this._cache = new te(), r.debug("Database: Created new HotCache instance in cache getter"), this._json && (this._json.setCache(this._cache), r.debug("Database: Connected cache to existing JSON table"))), this._json && this._json.cache !== this._cache && (r.debug("Database: Reconnecting cache to JSON table (instances differed)"), this._json.setCache(this._cache)), this._cache;
  }
  /**
   * Execute a SQL statement (INSERT, UPDATE, DELETE, CREATE, etc.)
   */
  async exec(e, t) {
    return await this.connection.exec(e, t);
  }
  /**
   * Execute a SELECT query and return all rows
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds (overrides connection default)
   * @returns Promise resolving to array of result rows
   * @throws QueryError if query fails or times out
   */
  async query(e, t, i) {
    return await this.connection.query(e, t, i);
  }
  /**
   * Execute a SELECT query and return the first row
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds (overrides connection default)
   * @returns Promise resolving to first row or null
   * @throws QueryError if query fails or times out
   */
  async queryOne(e, t, i) {
    return await this.connection.queryOne(e, t, i);
  }
  /**
   * Execute a SELECT query and return a single value
   * 
   * @param sql - SQL query string
   * @param params - Optional query parameters
   * @param timeout - Optional query timeout in milliseconds (overrides connection default)
   * @returns Promise resolving to single value or null
   * @throws QueryError if query fails or times out
   */
  async queryValue(e, t, i) {
    return await this.connection.queryValue(e, t, i);
  }
  /**
   * Execute a function within a transaction
   */
  async transaction(e) {
    try {
      const t = this.connection.getEngine();
      return await this.connection.transaction(async () => await e({
        exec: async (n, s) => {
          await t.exec(n, s);
        },
        query: async (n, s) => await this.connection.query(n, s),
        queryOne: async (n, s) => await this.connection.queryOne(n, s)
      }));
    } catch (t) {
      throw new ae(
        `Transaction failed: ${t instanceof Error ? t.message : String(t)}`,
        { error: t }
      );
    }
  }
  /**
   * Run database migrations
   */
  async migrate(e) {
    await P(this.connection).migrate(e);
  }
  /**
   * Get current migration version
   */
  async getMigrationVersion() {
    return await P(this.connection).getCurrentVersion();
  }
  /**
   * Get migration status
   */
  async getMigrationStatus(e) {
    return await P(this.connection).getStatus(e);
  }
  /**
   * Get storage information
   */
  async getStorageInfo() {
    const e = this.connection.getStorageType();
    return await Te(e);
  }
  /**
   * Get prepared statement cache statistics
   */
  getCacheStats() {
    const t = this.connection.getStatementCache().getStats();
    return {
      size: t.size,
      maxSize: t.maxSize,
      hitRate: t.hitRate
    };
  }
  /**
   * Get performance metrics
   */
  getMetrics() {
    const e = $.getMetrics(), t = this._cache?.getStats() || {
      size: 0,
      maxSize: 0,
      hits: 0,
      misses: 0,
      hitRate: 0,
      evictions: 0
    };
    return {
      queries: e.queries,
      writes: e.writes,
      cache: {
        ...t,
        hits: e.cache.hits || t.hits,
        misses: e.cache.misses || t.misses,
        evictions: e.cache.evictions || t.evictions
      },
      indexes: e.indexes
    };
  }
  /**
   * Reset performance metrics
   */
  resetMetrics() {
    r.resetMetrics(), $.reset(), this._cache?.resetStats(), this._batch?.resetStats();
  }
  /**
   * Close the database connection
   */
  async close() {
    await K().closeConnection(this.dbName, this.connection.getStorageType());
  }
  /**
   * Force immediate save to IndexedDB (flush pending changes)
   * Useful when you want to ensure data is persisted before navigating away
   */
  async flush(e = !1) {
    await this.connection.flush(e);
  }
  /**
   * Get database name
   */
  getName() {
    return this.dbName;
  }
  /**
   * Get storage type
   */
  getStorageType() {
    return this.connection.getStorageType();
  }
  /**
   * Check if database is connected
   */
  isConnected() {
    return this.connection.isConnected();
  }
}
async function We(a) {
  a.verbose && r.setLevel(V.DEBUG);
  try {
    const t = await K().getConnection(a);
    return new je(t);
  } catch (e) {
    throw new L(
      `Failed to connect to database: ${e instanceof Error ? e.message : String(e)}`,
      { options: a, error: e }
    );
  }
}
async function He() {
  await K().closeAll();
}
const yt = {
  connect: We,
  closeAll: He,
  createLogger: ce,
  LogLevel: V
};
export {
  Fe as BatchWriter,
  L as ConnectionError,
  je as Database,
  te as HotCache,
  I as HuniDBError,
  ze as IndexedDBShadow,
  D as InitializationError,
  V as LogLevel,
  Ae as MetricsCollector,
  C as MigrationError,
  f as QueryError,
  b as SchemaError,
  z as StorageError,
  Me as TimeSeriesTable,
  ae as TransactionError,
  ft as buildBetweenClause,
  ht as buildCount,
  ct as buildDelete,
  ut as buildInClause,
  at as buildInsert,
  mt as buildPagination,
  rt as buildSelect,
  ot as buildUpdate,
  Ke as clearStorage,
  He as closeAll,
  Ze as column,
  gt as combineConditions,
  We as connect,
  Je as createJSONTable,
  ce as createLogger,
  yt as default,
  r as defaultLogger,
  Ye as defineTable,
  Q as detectStorageCapabilities,
  Ge as dropJSONTable,
  lt as escapeIdentifier,
  dt as formatValue,
  it as generateCreateIndexSQL,
  tt as generateCreateTableSQL,
  st as generateDropIndexSQL,
  nt as generateDropTableSQL,
  be as getBrowserInfo,
  et as index,
  Ve as isStorageAvailable,
  $ as metricsCollector,
  Y as selectStorageType,
  Xe as setLivePagePredicate,
  Qe as validateStorageCompatibility,
  oe as wrapError
};
//# sourceMappingURL=index.js.map
